// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'https://api-dev.reedy.ai' | (string & {});
};

/**
 * APlusContentModule
 */
export type APlusContentModule = {
    /**
     * Type
     */
    type: string;
    /**
     * Count
     */
    count: number;
};

/**
 * APlusContentStatus
 *
 * `unknown` means the ISBN maps to no ASIN, so Amazon has nothing to check.
 */
export enum APlusContentStatus {
    PUBLISHED = 'published',
    NONE = 'none',
    UNKNOWN = 'unknown'
}

/**
 * APlusGenerationSummary
 */
export type APlusGenerationSummary = {
    /**
     * Status
     *
     * A page that failed after it was generated counts as generated.
     */
    status: 'generating' | 'failed' | 'generated';
};

/**
 * AccountOrganisationCreateRequest
 */
export type AccountOrganisationCreateRequest = {
    /**
     * Name
     */
    name: string;
    /**
     * Emails
     */
    emails?: Array<string> | null;
    /**
     * Targetgroups
     */
    targetGroups?: Array<FirestoreOrganisationTargetGroups> | null;
    /**
     * Disablepromptguard
     */
    disablePromptGuard?: boolean | null;
    settings?: FirestoreOrganisationSettings;
    /**
     * Descriptionsdefault
     */
    descriptionsDefault?: string | null;
    /**
     * Descriptionstypes
     */
    descriptionsTypes?: {
        [key: string]: number;
    } | null;
    /**
     * Createdat
     */
    createdAt?: Date;
    /**
     * Deletedat
     */
    deletedAt?: Date | null;
    /**
     * Harddeletedat
     */
    hardDeletedAt?: Date | null;
};

/**
 * AccountOrganisationFileRequest
 */
export type AccountOrganisationFileRequest = {
    /**
     * Upload
     */
    upload?: Blob | File | null;
};

/**
 * AccountOrganisationFileResponse
 */
export type AccountOrganisationFileResponse = {
    /**
     * Name
     */
    name: string;
    /**
     * Size
     */
    size: number;
    /**
     * Url
     */
    url: string;
    /**
     * Date
     */
    date?: Date | null;
};

/**
 * AccountOrganisationResponse
 */
export type AccountOrganisationResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Emails
     */
    emails?: Array<string> | null;
    /**
     * Targetgroups
     */
    targetGroups?: Array<FirestoreOrganisationTargetGroups> | null;
    /**
     * Disablepromptguard
     */
    disablePromptGuard?: boolean | null;
    settings?: FirestoreOrganisationSettings;
    /**
     * Descriptionsdefault
     */
    descriptionsDefault?: string | null;
    /**
     * Descriptionstypes
     */
    descriptionsTypes?: {
        [key: string]: number;
    } | null;
    /**
     * Createdat
     */
    createdAt?: Date;
    /**
     * Deletedat
     */
    deletedAt?: Date | null;
    /**
     * Harddeletedat
     */
    hardDeletedAt?: Date | null;
};

/**
 * AccountOrganisationSettingsUpdateRequest
 */
export type AccountOrganisationSettingsUpdateRequest = {
    /**
     * Inactiveproductstatus
     */
    inactiveProductStatus?: Array<ProductAvailabilityCodeLiteral> | null;
    /**
     * Excludenoavailabilitycode
     */
    excludeNoAvailabilityCode?: boolean | null;
    language?: FirestoreOrganisationLanguage | null;
    marketplace?: FirestoreOrganisationMarketplace | null;
};

/**
 * AccountOrganisationUpdateRequest
 */
export type AccountOrganisationUpdateRequest = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Emails
     */
    emails?: Array<string> | null;
    /**
     * Targetgroups
     */
    targetGroups?: Array<FirestoreOrganisationTargetGroups> | null;
    /**
     * Disablepromptguard
     */
    disablePromptGuard?: boolean | null;
    settings?: FirestoreOrganisationSettings;
    /**
     * Descriptionsdefault
     */
    descriptionsDefault?: string | null;
    /**
     * Descriptionstypes
     */
    descriptionsTypes?: {
        [key: string]: number;
    } | null;
    /**
     * Createdat
     */
    createdAt?: Date;
    /**
     * Deletedat
     */
    deletedAt?: Date | null;
    /**
     * Harddeletedat
     */
    hardDeletedAt?: Date | null;
};

/**
 * AccountOrganisationsResponse
 */
export type AccountOrganisationsResponse = {
    /**
     * Items
     */
    items?: Array<AccountOrganisationResponse>;
};

/**
 * AccountUserApiKeyCreatedResponse
 */
export type AccountUserApiKeyCreatedResponse = {
    /**
     * Api Key
     */
    api_key: string;
    user_api_key: FirestoreUserApiKey;
};

/**
 * AccountUserApiKeyRequest
 */
export type AccountUserApiKeyRequest = {
    /**
     * Name
     */
    name?: string | null;
};

/**
 * AccountUserApiKeysResponse
 */
export type AccountUserApiKeysResponse = {
    /**
     * Items
     */
    items?: Array<FirestoreUserApiKey>;
};

/**
 * AccountUserCreateRequest
 */
export type AccountUserCreateRequest = {
    /**
     * Email
     */
    email: string;
    /**
     * Givenname
     */
    givenName?: string | null;
    /**
     * Familyname
     */
    familyName?: string | null;
    /**
     * Deletedat
     */
    deletedAt?: Date | null;
};

/**
 * AccountUserResponse
 */
export type AccountUserResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Email
     */
    email: string;
    /**
     * Givenname
     */
    givenName?: string | null;
    /**
     * Familyname
     */
    familyName?: string | null;
    organisation?: OrganisationShort | null;
    /**
     * Roles
     */
    roles?: Array<UserRole> | null;
    /**
     * Deletedat
     */
    deletedAt?: Date | null;
};

/**
 * AccountUserUpdateRequest
 */
export type AccountUserUpdateRequest = {
    /**
     * Email
     */
    email?: string | null;
    /**
     * Givenname
     */
    givenName?: string | null;
    /**
     * Familyname
     */
    familyName?: string | null;
    /**
     * Roles
     */
    roles?: Array<UserRole> | null;
    /**
     * Deletedat
     */
    deletedAt?: Date | null;
};

/**
 * AccountUsersResponse
 */
export type AccountUsersResponse = {
    /**
     * Items
     */
    items?: Array<UserResponse>;
};

/**
 * AcpAvailability
 */
export type AcpAvailability = {
    /**
     * Available
     */
    available: boolean;
    /**
     * Status
     */
    status: 'in_stock' | 'backorder' | 'preorder' | 'out_of_stock' | 'discontinued';
};

/**
 * AcpBarcode
 */
export type AcpBarcode = {
    /**
     * Type
     */
    type: 'gtin';
    /**
     * Value
     */
    value: string;
};

/**
 * AcpCategory
 */
export type AcpCategory = {
    /**
     * Value
     */
    value: string;
    /**
     * Taxonomy
     */
    taxonomy?: string | null;
};

/**
 * AcpDescription
 */
export type AcpDescription = {
    /**
     * Plain
     */
    plain?: string | null;
    /**
     * Html
     */
    html?: string | null;
    /**
     * Markdown
     */
    markdown?: string | null;
};

/**
 * AcpExportRequest
 */
export type AcpExportRequest = {
    /**
     * Count
     */
    count?: number | null;
};

/**
 * AcpExportResponse
 */
export type AcpExportResponse = {
    /**
     * Exportid
     */
    exportId: string;
};

/**
 * AcpLink
 */
export type AcpLink = {
    /**
     * Type
     */
    type: 'privacy_policy' | 'terms_of_service' | 'refund_policy' | 'shipping_policy' | 'faq';
    /**
     * Url
     */
    url: string;
    /**
     * Title
     */
    title?: string | null;
};

/**
 * AcpMedia
 */
export type AcpMedia = {
    /**
     * Type
     */
    type: 'image';
    /**
     * Url
     */
    url: string;
    /**
     * Alt Text
     */
    alt_text?: string | null;
    /**
     * Width
     */
    width?: number | null;
    /**
     * Height
     */
    height?: number | null;
};

/**
 * AcpPrice
 */
export type AcpPrice = {
    /**
     * Amount
     */
    amount: number;
    /**
     * Currency
     */
    currency: string;
};

/**
 * AcpProduct
 */
export type AcpProduct = {
    /**
     * Id
     */
    id: string;
    /**
     * Title
     */
    title?: string | null;
    description?: AcpDescription | null;
    /**
     * Url
     */
    url?: string | null;
    /**
     * Media
     */
    media?: Array<AcpMedia> | null;
    /**
     * Variants
     */
    variants: Array<AcpVariant>;
};

/**
 * AcpSeller
 */
export type AcpSeller = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Links
     */
    links?: Array<AcpLink> | null;
};

/**
 * AcpVariant
 */
export type AcpVariant = {
    /**
     * Id
     */
    id: string;
    /**
     * Title
     */
    title: string;
    description?: AcpDescription | null;
    /**
     * Url
     */
    url?: string | null;
    /**
     * Barcodes
     */
    barcodes?: Array<AcpBarcode> | null;
    price?: AcpPrice | null;
    list_price?: AcpPrice | null;
    availability?: AcpAvailability | null;
    /**
     * Categories
     */
    categories?: Array<AcpCategory> | null;
    /**
     * Condition
     */
    condition?: Array<string> | null;
    /**
     * Variant Options
     */
    variant_options?: Array<AcpVariantOption> | null;
    /**
     * Media
     */
    media?: Array<AcpMedia> | null;
    seller?: AcpSeller | null;
};

/**
 * AcpVariantOption
 */
export type AcpVariantOption = {
    /**
     * Name
     */
    name: string;
    /**
     * Value
     */
    value: string;
};

/**
 * AgeRangeAvailableBounds
 *
 * Per age-type slider bounds; null when no product carries that type.
 */
export type AgeRangeAvailableBounds = {
    interest_age_months?: AgeRangeBound | null;
    interest_age_years?: AgeRangeBound | null;
    reading_age_years?: AgeRangeBound | null;
};

/**
 * AgeRangeBound
 */
export type AgeRangeBound = {
    /**
     * Min
     */
    min: number;
    /**
     * Max
     */
    max: number;
};

/**
 * AgeRangeFilter
 */
export type AgeRangeFilter = {
    age_type: AgeType;
    /**
     * Gte
     */
    gte: number;
    /**
     * Lte
     */
    lte: number;
};

/**
 * AgeType
 */
export enum AgeType {
    INTEREST_AGE_MONTHS = 'interest_age_months',
    INTEREST_AGE_YEARS = 'interest_age_years',
    READING_AGE_YEARS = 'reading_age_years'
}

/**
 * AggregationBucket
 */
export type AggregationBucket = {
    /**
     * Field
     */
    field: string;
    /**
     * Buckets
     */
    buckets: Array<AggregationResult>;
};

/**
 * AggregationResult
 */
export type AggregationResult = {
    /**
     * Key
     */
    key: string;
    /**
     * Doc Count
     */
    doc_count: number;
    /**
     * Label
     */
    label?: string | null;
    /**
     * Kind
     */
    kind?: string | null;
    /**
     * Seq
     */
    seq?: number | null;
    /**
     * Subject Code
     */
    subject_code?: string | null;
    /**
     * Subject Label
     */
    subject_label?: string | null;
};

/**
 * AmazonSalesBucket
 *
 * One time bucket of Amazon signals. `byIsbn` is set on bundle reads.
 */
export type AmazonSalesBucket = {
    /**
     * Date
     */
    date: string;
    /**
     * Units
     */
    units: number | null;
    /**
     * Revenue
     */
    revenue: number | null;
    /**
     * Pageviews
     */
    pageViews: number | null;
    /**
     * Conversionrate
     */
    conversionRate: number | null;
    /**
     * Salesrank
     */
    salesRank: number | null;
    /**
     * Salesrankdate
     */
    salesRankDate: string | null;
    /**
     * Worstsalesrank
     */
    worstSalesRank: number | null;
    /**
     * Worstsalesrankdate
     */
    worstSalesRankDate: string | null;
    /**
     * Byisbn
     */
    byIsbn?: {
        [key: string]: AmazonSalesIsbnBucket;
    } | null;
};

/**
 * AmazonSalesIsbnBucket
 *
 * One format's Amazon signals within a bucket. Null fields mean no source rows.
 */
export type AmazonSalesIsbnBucket = {
    /**
     * Units
     */
    units?: number | null;
    /**
     * Revenue
     */
    revenue?: number | null;
    /**
     * Pageviews
     */
    pageViews?: number | null;
    /**
     * Conversionrate
     */
    conversionRate?: number | null;
    /**
     * Salesrank
     */
    salesRank?: number | null;
    /**
     * Salesrankdate
     */
    salesRankDate?: string | null;
    /**
     * Worstsalesrank
     */
    worstSalesRank?: number | null;
    /**
     * Worstsalesrankdate
     */
    worstSalesRankDate?: string | null;
};

/**
 * AmazonSalesResponse
 */
export type AmazonSalesResponse = {
    /**
     * Type
     */
    type: 'amazon';
    /**
     * Isbn
     */
    isbn: string;
    range: BookSalesRange;
    /**
     * Currency
     */
    currency: string | null;
    /**
     * Buckets
     */
    buckets: Array<AmazonSalesBucket>;
    summary: AmazonSalesSummary;
};

/**
 * AmazonSalesSummary
 *
 * Window totals. Share compares Amazon units to the market panel.
 */
export type AmazonSalesSummary = {
    /**
     * Totalunits
     */
    totalUnits: number;
    /**
     * Totalrevenue
     */
    totalRevenue: number | null;
    /**
     * Averageconversionrate
     */
    averageConversionRate: number | null;
    /**
     * Totalpageviews
     */
    totalPageViews: number | null;
    /**
     * Bestrank
     */
    bestRank: number | null;
    /**
     * Worstrank
     */
    worstRank: number | null;
    /**
     * Amazonshareoftotalunits
     */
    amazonShareOfTotalUnits: number | null;
};

/**
 * ApiResponseAccountOrganisationFileResponseStatus200
 */
export type ApiResponseAccountOrganisationFileResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: AccountOrganisationFileResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseAccountOrganisationResponseStatus200
 */
export type ApiResponseAccountOrganisationResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: AccountOrganisationResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseAccountOrganisationsResponseStatus200
 */
export type ApiResponseAccountOrganisationsResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: AccountOrganisationsResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseAccountUserApiKeyCreatedResponseStatus200
 */
export type ApiResponseAccountUserApiKeyCreatedResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: AccountUserApiKeyCreatedResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseAccountUserApiKeysResponseStatus200
 */
export type ApiResponseAccountUserApiKeysResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: AccountUserApiKeysResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseAccountUserResponseStatus200
 */
export type ApiResponseAccountUserResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: AccountUserResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseAccountUsersResponseStatus200
 */
export type ApiResponseAccountUsersResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: AccountUsersResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseMessageStatus200
 */
export type ApiResponseApiResponseMessageStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseMessage | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseMessageStatus400
 */
export type ApiResponseApiResponseMessageStatus400 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseMessage | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseMessageStatus401
 */
export type ApiResponseApiResponseMessageStatus401 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseMessage | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseMessageStatus403
 */
export type ApiResponseApiResponseMessageStatus403 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseMessage | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseMessageStatus404
 */
export type ApiResponseApiResponseMessageStatus404 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseMessage | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseMessageStatus429
 */
export type ApiResponseApiResponseMessageStatus429 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseMessage | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseMessageStatus500
 */
export type ApiResponseApiResponseMessageStatus500 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseMessage | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseMessageStatus502
 */
export type ApiResponseApiResponseMessageStatus502 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseMessage | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseMessageStatus503
 */
export type ApiResponseApiResponseMessageStatus503 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseMessage | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseApiResponseValidationErrorStatus422
 */
export type ApiResponseApiResponseValidationErrorStatus422 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ApiResponseValidationError | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseBisacCodesResponseStatus200
 */
export type ApiResponseBisacCodesResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: BisacCodesResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseBisacSearchResponseStatus200
 */
export type ApiResponseBisacSearchResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: BisacSearchResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseEvaluationResponseStatus200
 */
export type ApiResponseEvaluationResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: EvaluationResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseEvaluationsResponseStatus200
 */
export type ApiResponseEvaluationsResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: EvaluationsResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseGalleyBookResponseStatus200
 */
export type ApiResponseGalleyBookResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: GalleyBookResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseGalleyProjectStatus200
 */
export type ApiResponseGalleyProjectStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: GalleyProject | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseGalleyProjectStatus201
 */
export type ApiResponseGalleyProjectStatus201 = {
    /**
     * Success
     */
    success?: boolean;
    data?: GalleyProject | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseGalleySearchResponseStatus200
 */
export type ApiResponseGalleySearchResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: GalleySearchResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseGalleySeasonalEventListStatus200
 */
export type ApiResponseGalleySeasonalEventListStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: GalleySeasonalEventList | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseKeywordFeedbackResponseStatus200
 */
export type ApiResponseKeywordFeedbackResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: KeywordFeedbackResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseKeywordFeedbackResponseStatus201
 */
export type ApiResponseKeywordFeedbackResponseStatus201 = {
    /**
     * Success
     */
    success?: boolean;
    data?: KeywordFeedbackResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseMessage
 */
export type ApiResponseMessage = {
    /**
     * Message
     */
    message: string;
};

/**
 * ApiResponseProductAcpFeedPreviewResponseStatus200
 */
export type ApiResponseProductAcpFeedPreviewResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductAcpFeedPreviewResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductAmplifyAPlusContentResponseStatus200
 */
export type ApiResponseProductAmplifyAPlusContentResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductAmplifyAPlusContentResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductCreationResponseStatus200
 */
export type ApiResponseProductCreationResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductCreationResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductDeletionResponseStatus200
 */
export type ApiResponseProductDeletionResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductDeletionResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductGenerationResponseBulkStatus200
 */
export type ApiResponseProductGenerationResponseBulkStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductGenerationResponseBulk | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductGenerationResponseStatus200
 */
export type ApiResponseProductGenerationResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductGenerationResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductRawResponseStatus200
 */
export type ApiResponseProductRawResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductRawResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductResponseStatus200
 */
export type ApiResponseProductResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductSearchResponseStatus200
 */
export type ApiResponseProductSearchResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductSearchResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductsAmplifySummariesResponseStatus200
 */
export type ApiResponseProductsAmplifySummariesResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductsAmplifySummariesResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProductsExportResponseStatus200
 */
export type ApiResponseProductsExportResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProductsExportResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseProjectAmplifyProductsResponseStatus200
 */
export type ApiResponseProjectAmplifyProductsResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ProjectAmplifyProductsResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseSalesInfoResponseStatus200
 */
export type ApiResponseSalesInfoResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: SalesInfoResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseSalesResponseStatus200
 */
export type ApiResponseSalesResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: SalesResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseThemaCodesResponseStatus200
 */
export type ApiResponseThemaCodesResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ThemaCodesResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseThemaSearchResponseStatus200
 */
export type ApiResponseThemaSearchResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: ThemaSearchResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseUserProfileStatus200
 */
export type ApiResponseUserProfileStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: UserProfile | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseV1MetadataBlurbResponseStatus200
 */
export type ApiResponseV1MetadataBlurbResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: V1MetadataBlurbResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseV1MetadataKeywordResponseStatus200
 */
export type ApiResponseV1MetadataKeywordResponseStatus200 = {
    /**
     * Success
     */
    success?: boolean;
    data?: V1MetadataKeywordResponse | null;
    /**
     * Code
     */
    code?: number;
};

/**
 * ApiResponseValidationError
 */
export type ApiResponseValidationError = {
    /**
     * Message
     */
    message: string;
    /**
     * Errors
     */
    errors: Array<ValidationErrorDetail>;
};

/**
 * AuthorFilter
 */
export type AuthorFilter = {
    /**
     * Authors
     */
    authors: Array<string>;
};

/**
 * BisacCode
 *
 * A BISAC subject code from the catalogue.
 */
export type BisacCode = {
    /**
     * Code
     */
    code: string;
    /**
     * Headingpath
     */
    headingPath: Array<string>;
    /**
     * Seealso
     */
    seeAlso: Array<string>;
    /**
     * Seq
     */
    seq: number;
};

/**
 * BisacCodeCountFilter
 */
export type BisacCodeCountFilter = {
    operator: FilterOperator;
    /**
     * Value
     */
    value: number;
};

/**
 * BisacCodesFilter
 */
export type BisacCodesFilter = {
    /**
     * Codes
     */
    codes: Array<string>;
};

/**
 * BisacCodesResponse
 *
 * Response model for the whole BISAC catalogue (/bisac/codes).
 */
export type BisacCodesResponse = {
    /**
     * Edition
     */
    edition: string;
    /**
     * Codes
     */
    codes: Array<BisacCode>;
};

/**
 * BisacSearchHit
 *
 * A BISAC code that matched a search, with the matched heading text marked.
 */
export type BisacSearchHit = {
    /**
     * Code
     */
    code: string;
    /**
     * Headingpath
     */
    headingPath: Array<string>;
    /**
     * Seealso
     */
    seeAlso: Array<string>;
    /**
     * Seq
     */
    seq: number;
    /**
     * Highlightedheading
     */
    highlightedHeading?: string | null;
};

/**
 * BisacSearchResponse
 *
 * Response model for BISAC search (/bisac/search).
 */
export type BisacSearchResponse = {
    /**
     * Codes
     */
    codes: Array<BisacSearchHit>;
};

/**
 * BookSalesBucket
 *
 * One time bucket with per-market totals. `byIsbn` is set on bundle reads.
 */
export type BookSalesBucket = {
    /**
     * Date
     */
    date: string;
    /**
     * Bymarket
     */
    byMarket: {
        [key: string]: BookSalesMarketBucket;
    };
    /**
     * Byisbn
     */
    byIsbn: {
        [key: string]: BookSalesIsbnBucket;
    } | null;
};

/**
 * BookSalesIsbnBucket
 *
 * One format's contribution to a bucket, with per-market revenue grain.
 */
export type BookSalesIsbnBucket = {
    /**
     * Bymarket
     */
    byMarket: {
        [key: string]: BookSalesMarketBucket;
    };
};

/**
 * BookSalesMarketBucket
 *
 * Units and native-currency revenue for one market within one bucket.
 */
export type BookSalesMarketBucket = {
    /**
     * Units
     */
    units: number;
    /**
     * Revenue
     */
    revenue: number | null;
};

/**
 * BookSalesMarketMeta
 *
 * A market present in the result and the currency its revenue is in.
 */
export type BookSalesMarketMeta = {
    /**
     * Market
     */
    market: string;
    /**
     * Currency
     */
    currency: string;
};

/**
 * BookSalesPeak
 *
 * Best-revenue day within the window, independent of chart granularity.
 *
 * The summary cards use this so the peak date is the actual day, not the
 * Monday week-start of a weekly bucket.
 */
export type BookSalesPeak = {
    /**
     * Date
     */
    date: string;
    /**
     * Bymarket
     */
    byMarket: {
        [key: string]: BookSalesMarketBucket;
    };
};

/**
 * BookSalesRange
 *
 * Echoes the resolved window so the client can label the chart.
 *
 * `granularity` is the effective bucket size actually served (the requested
 * one, clamped into `availableGranularities` when it didn't fit the span).
 * `availableGranularities` is the full set valid for this window, so the
 * client drives its granularity picker entirely from the response.
 */
export type BookSalesRange = {
    /**
     * Start
     */
    start: string;
    /**
     * End
     */
    end: string;
    granularity: Granularity;
    /**
     * Availablegranularities
     */
    availableGranularities: Array<Granularity>;
};

/**
 * BookSalesResponse
 */
export type BookSalesResponse = {
    /**
     * Type
     */
    type: 'market';
    /**
     * Isbn
     */
    isbn: string;
    range: BookSalesRange;
    /**
     * Markets
     */
    markets: Array<BookSalesMarketMeta>;
    /**
     * Buckets
     */
    buckets: Array<BookSalesBucket>;
    peak?: BookSalesPeak | null;
};

/**
 * DescriptionLengthFilter
 */
export type DescriptionLengthFilter = {
    operator: FilterOperator;
    /**
     * Value
     */
    value: number;
};

/**
 * DescriptionWordCountFilter
 */
export type DescriptionWordCountFilter = {
    operator: FilterOperator;
    /**
     * Value
     */
    value: number;
};

/**
 * EvaluationRequest
 */
export type EvaluationRequest = {
    /**
     * Requestedproducts
     *
     * The requested products of the evaluation
     */
    requestedProducts: 'ALL' | Array<string>;
    /**
     * Mode
     *
     * The mode of the evaluation
     */
    mode?: 'SYNC' | 'ASYNC';
};

/**
 * EvaluationResponse
 */
export type EvaluationResponse = {
    /**
     * Id
     *
     * The id of the evaluation
     */
    id: string;
    /**
     * The status of the evaluation
     */
    status: FirestoreGenerationStatus;
    /**
     * The status code of the evaluation
     */
    statusCode: FirestoreGenerationStatusCode | null;
    /**
     * Createdat
     *
     * The creation date of the evaluation
     */
    createdAt: Date;
    /**
     * Updatedat
     *
     * The update date of the evaluation
     */
    updatedAt: Date | null;
    /**
     * Mode
     */
    mode?: 'SYNC' | 'ASYNC';
    /**
     * Requestedproducts
     */
    requestedProducts: 'ALL' | Array<string>;
    /**
     * File
     */
    file?: {
        [key: string]: unknown;
    } | null;
};

/**
 * EvaluationsResponse
 */
export type EvaluationsResponse = {
    /**
     * Items
     *
     * The list of evaluations
     */
    items: Array<EvaluationResponse>;
};

/**
 * FailedRequestInfo
 */
export type FailedRequestInfo = {
    /**
     * Productid
     *
     * The ID of the product that failed generation
     */
    productId: string;
    /**
     * Reason
     *
     * The reason why the generation failed
     */
    reason: string;
};

/**
 * FilterOperator
 */
export enum FilterOperator {
    GT = 'gt',
    LT = 'lt',
    EQ = 'eq'
}

/**
 * FirestoreGenerationStatus
 */
export enum FirestoreGenerationStatus {
    IMPORTED = 'IMPORTED',
    REQUESTED = 'REQUESTED',
    GENERATING = 'GENERATING',
    GENERATED = 'GENERATED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    ERROR = 'ERROR'
}

/**
 * FirestoreGenerationStatusCode
 */
export enum FirestoreGenerationStatusCode {
    _100 = '100',
    _102 = '102',
    _200 = '200',
    _402 = '402',
    _422 = '422',
    _451 = '451',
    _499 = '499',
    _500 = '500'
}

/**
 * FirestoreOrganisationAcpSettings
 */
export type FirestoreOrganisationAcpSettings = {
    /**
     * Feed Id
     */
    feed_id?: string | null;
    /**
     * Account Id
     */
    account_id?: string | null;
    /**
     * Target Merchant
     */
    target_merchant?: string | null;
    /**
     * Target Country
     */
    target_country?: string | null;
};

/**
 * FirestoreOrganisationLanguage
 */
export enum FirestoreOrganisationLanguage {
    EN_GB = 'en-GB',
    EN_US = 'en-US',
    DE_DE = 'de-DE'
}

/**
 * FirestoreOrganisationMarketplace
 */
export enum FirestoreOrganisationMarketplace {
    UK = 'UK',
    US = 'US',
    GER = 'GER',
    AU = 'AU',
    NONE = 'NONE'
}

/**
 * FirestoreOrganisationSalesDataLake
 *
 * Which sales data lake an organisation reads from.
 */
export enum FirestoreOrganisationSalesDataLake {
    MMDE = 'MMDE',
    PMUK = 'PMUK',
    MMUS = 'MMUS',
    DISABLED = 'DISABLED'
}

/**
 * FirestoreOrganisationSettings
 */
export type FirestoreOrganisationSettings = {
    /**
     * Inactiveproductstatus
     */
    inactiveProductStatus?: Array<ProductAvailabilityCodeLiteral>;
    /**
     * Excludenoavailabilitycode
     */
    excludeNoAvailabilityCode?: boolean;
    /**
     * Canseeamazonsearchterms
     */
    canSeeAmazonSearchTerms?: boolean | null;
    marketplace?: FirestoreOrganisationMarketplace | null;
    language?: FirestoreOrganisationLanguage | null;
    acpSettings?: FirestoreOrganisationAcpSettings | null;
    salesDataLake?: FirestoreOrganisationSalesDataLake;
};

/**
 * FirestoreOrganisationTargetGroups
 */
export type FirestoreOrganisationTargetGroups = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description: string;
};

/**
 * FirestoreProductActions
 */
export type FirestoreProductActions = {
    /**
     * Active
     */
    active?: boolean;
    /**
     * Errored
     */
    errored?: boolean;
    keywords?: FirestoreProductActionsKeywords;
    descriptions?: FirestoreProductActionsDescriptions | null;
    thema?: FirestoreProductActionsThema | null;
    manuscript?: FirestoreProductActionsManuscript | null;
    subtitle?: FirestoreProductActionsSubtitle | null;
};

/**
 * FirestoreProductActionsDescriptions
 */
export type FirestoreProductActionsDescriptions = {
    /**
     * Active
     */
    active?: boolean;
    /**
     * Errored
     */
    errored?: boolean;
    /**
     * Actions
     */
    actions?: {
        [key: string]: FirestoreProductActionsDescriptionsActions;
    };
};

/**
 * FirestoreProductActionsDescriptionsActions
 */
export type FirestoreProductActionsDescriptionsActions = {
    generate?: FirestoreProductActionsValue;
};

/**
 * FirestoreProductActionsKeywords
 */
export type FirestoreProductActionsKeywords = {
    /**
     * Active
     */
    active?: boolean;
    /**
     * Errored
     */
    errored?: boolean;
    actions?: FirestoreProductActionsKeywordsActions;
};

/**
 * FirestoreProductActionsKeywordsActions
 */
export type FirestoreProductActionsKeywordsActions = {
    rank?: FirestoreProductActionsValue | null;
    generate?: FirestoreProductActionsValue | null;
    autoFill?: FirestoreProductActionsValue | null;
};

/**
 * FirestoreProductActionsManuscript
 */
export type FirestoreProductActionsManuscript = {
    /**
     * Active
     */
    active?: boolean;
    /**
     * Errored
     */
    errored?: boolean;
    actions?: FirestoreProductActionsManuscriptActions | null;
};

/**
 * FirestoreProductActionsManuscriptActions
 */
export type FirestoreProductActionsManuscriptActions = {
    analyse?: FirestoreProductActionsValue | null;
};

/**
 * FirestoreProductActionsSubtitle
 */
export type FirestoreProductActionsSubtitle = {
    /**
     * Active
     */
    active?: boolean;
    /**
     * Errored
     */
    errored?: boolean;
    actions?: FirestoreProductActionsSubtitleActions | null;
};

/**
 * FirestoreProductActionsSubtitleActions
 */
export type FirestoreProductActionsSubtitleActions = {
    generate?: FirestoreProductActionsValue | null;
};

/**
 * FirestoreProductActionsThema
 */
export type FirestoreProductActionsThema = {
    /**
     * Active
     */
    active?: boolean;
    /**
     * Errored
     */
    errored?: boolean;
    actions?: FirestoreProductActionsThemaActions | null;
};

/**
 * FirestoreProductActionsThemaActions
 */
export type FirestoreProductActionsThemaActions = {
    generate?: FirestoreProductActionsValue | null;
};

/**
 * FirestoreProductActionsValue
 */
export type FirestoreProductActionsValue = {
    status?: FirestoreGenerationStatus | null;
    statusCode?: FirestoreGenerationStatusCode | null;
    /**
     * Msg
     */
    msg?: string;
};

/**
 * FirestoreProductAgeRange
 *
 * A normalized audience age range; either bound may be open-ended.
 */
export type FirestoreProductAgeRange = {
    /**
     * Gte
     */
    gte?: number | null;
    /**
     * Lte
     */
    lte?: number | null;
};

/**
 * FirestoreProductAgeRanges
 *
 * ONIX List 30 qualifiers 16/17/18 (see ``get_age_ranges``).
 */
export type FirestoreProductAgeRanges = {
    interestAgeMonths?: FirestoreProductAgeRange | null;
    interestAgeYears?: FirestoreProductAgeRange | null;
    readingAgeYears?: FirestoreProductAgeRange | null;
};

/**
 * FirestoreProductBisacSubject
 *
 * A BISAC code on a product, ordered by list position until the user selects it.
 *
 * A ``MANUAL`` entry is always ``final``: it exists only because the user selected
 * it, and an entry that is neither ``inSource`` nor ``final`` is deleted on the next
 * import.
 */
export type FirestoreProductBisacSubject = {
    /**
     * Id
     *
     * The identifier of the product's BISAC subject
     */
    id: string;
    /**
     * Subjectcode
     *
     * The BISAC subject code
     */
    subjectCode?: string;
    /**
     * Subjectheadingtext
     */
    subjectHeadingText?: string | null;
    /**
     * Who created the entry; never rewritten once set
     */
    source?: SubjectSource;
    /**
     * Insource
     *
     * Whether the latest imported ONIX file still carries the code
     */
    inSource?: boolean;
    /**
     * Final
     *
     * Whether the user selected the code
     */
    final?: boolean;
    /**
     * Orderindex
     *
     * Position among the codes the user selected
     */
    orderIndex?: number | null;
    /**
     * Seq
     *
     * Position of the code in the BISAC catalogue; set only when subjectHeadingText is the catalogue heading
     */
    seq?: number | null;
};

/**
 * FirestoreProductCategorization
 */
export type FirestoreProductCategorization = {
    /**
     * Fiction
     */
    fiction?: boolean;
    /**
     * Nonfiction
     */
    nonFiction?: boolean;
    /**
     * Children
     */
    children?: boolean;
    /**
     * Updatedat
     */
    updatedAt?: Date | null;
    /**
     * Inferredfrom
     */
    inferredFrom?: 'THEMA' | 'LLM' | null;
};

/**
 * FirestoreProductDescription
 */
export type FirestoreProductDescription = {
    /**
     * Hash
     */
    hash?: string;
    /**
     * Default
     */
    default?: boolean;
    /**
     * Textgenerated
     */
    textGenerated?: string;
    /**
     * Text
     */
    text?: string;
    /**
     * Textformat
     */
    textFormat?: string;
    /**
     * Texttype
     */
    textType?: string;
    /**
     * Audiences
     */
    audiences?: Array<string>;
};

/**
 * FirestoreProductDimensions
 *
 * Lengths in mm, weight in grams; keys match ``normalize_dimensions`` output.
 */
export type FirestoreProductDimensions = {
    /**
     * Width
     */
    width?: number | null;
    /**
     * Height
     */
    height?: number | null;
    /**
     * Thickness
     */
    thickness?: number | null;
    /**
     * Weight
     */
    weight?: number | null;
    /**
     * Pages
     */
    pages?: number | null;
    /**
     * Flaps
     */
    flaps?: number | null;
};

/**
 * FirestoreProductIdentifier
 */
export type FirestoreProductIdentifier = {
    /**
     * Type
     */
    type: string;
    /**
     * Value
     */
    value: string;
};

/**
 * FirestoreProductImages
 */
export type FirestoreProductImages = {
    /**
     * Frontcoverurl
     */
    frontCoverUrl?: string;
    /**
     * Backcoverurl
     */
    backCoverUrl?: string;
    /**
     * Supportingresources
     */
    supportingResources?: Array<{
        [key: string]: unknown;
    }>;
};

/**
 * FirestoreProductImportData
 */
export type FirestoreProductImportData = {
    /**
     * Importid
     */
    importId: string;
    /**
     * Productsimportid
     */
    productsImportId: string;
    /**
     * Objectname
     */
    objectName: string;
    /**
     * Foldername
     */
    folderName: string;
    /**
     * Filename
     */
    fileName: string;
    /**
     * Chunkid
     */
    chunkId?: string | null;
};

/**
 * FirestoreProductManuscript
 */
export type FirestoreProductManuscript = {
    /**
     * Filename
     */
    filename: string;
    /**
     * Uploadedat
     */
    uploadedAt: Date;
    analysis?: FirestoreProductManuscriptAnalysis | null;
};

/**
 * FirestoreProductManuscriptAnalysis
 */
export type FirestoreProductManuscriptAnalysis = {
    /**
     * Result
     */
    result?: string | null;
    /**
     * Generatedcontentid
     */
    generatedContentId?: string | null;
    /**
     * Generatedat
     */
    generatedAt?: Date | null;
    /**
     * Generationrequestid
     */
    generationRequestId?: string | null;
};

/**
 * FirestoreProductPublisher
 */
export type FirestoreProductPublisher = {
    /**
     * Name
     */
    name: string;
    /**
     * Role
     */
    role: string | null;
};

/**
 * FirestoreProductQuote
 */
export type FirestoreProductQuote = {
    /**
     * Text
     */
    text?: string;
    /**
     * Source
     */
    source?: string;
};

/**
 * FirestoreProductSeries
 */
export type FirestoreProductSeries = {
    /**
     * What the publisher declared in ONIX, not a verified fact: in_series when it sent a <Collection>, not_in_series when it sent <NoCollection/>, unknown when it sent neither. Some feeds send <NoCollection/> on every product without a <Collection>.
     */
    status?: SeriesStatus;
    /**
     * Items
     */
    items?: Array<FirestoreProductSeriesItem>;
};

/**
 * FirestoreProductSeriesIdentifier
 */
export type FirestoreProductSeriesIdentifier = {
    /**
     * Type
     */
    type: string;
    /**
     * Idtypename
     */
    idTypeName?: string | null;
    /**
     * Value
     */
    value: string;
};

/**
 * FirestoreProductSeriesItem
 *
 * One ONIX <Collection> the product belongs to, as the publisher sent it.
 */
export type FirestoreProductSeriesItem = {
    /**
     * Title
     */
    title?: string | null;
    /**
     * ONIX title element level (List 149) of the collection title.
     */
    level?: SeriesLevel | null;
    /**
     * Number
     *
     * The product's position in the series, kept as sent (e.g. '01', '1 und 2', 'Prequel').
     */
    number?: string | null;
    /**
     * The ONIX element the number comes from: <CollectionSequence> or <PartNumber>.
     */
    numberSource?: SeriesNumberSource | null;
    /**
     * The <CollectionSequenceType> of the number. Null when the number comes from <PartNumber>, which declares no order, or when the type is not in ONIX List 197.
     */
    orderType?: SeriesOrderType | null;
    /**
     * Identifiers
     */
    identifiers?: Array<FirestoreProductSeriesIdentifier>;
};

/**
 * FirestoreProductSubject
 */
export type FirestoreProductSubject = {
    /**
     * Id
     *
     * The identifier of the product's subject
     */
    id?: string | null;
    /**
     * Responseid
     */
    responseId?: string | null;
    source?: SubjectSource | null;
    /**
     * Subjectcode
     */
    subjectCode?: string | null;
    /**
     * Subjectheadingtext
     */
    subjectHeadingText?: string | null;
    /**
     * Reasoning
     */
    reasoning?: string | null;
    /**
     * Subjectschemeidentifier
     */
    subjectSchemeIdentifier?: string | null;
    /**
     * Ranking
     */
    ranking?: number | null;
    /**
     * Rankingreasoning
     */
    rankingReasoning?: string | null;
    /**
     * Keywordsearchquery
     */
    keywordSearchQuery?: string | null;
    /**
     * Databaseindex
     */
    databaseIndex?: number | null;
    /**
     * Hotnessscore
     */
    hotnessScore?: number | null;
};

/**
 * FirestoreProductSubjects
 */
export type FirestoreProductSubjects = {
    /**
     * Generated
     *
     * The generated subjects
     */
    generated?: Array<FirestoreProductSubject> | null;
    /**
     * Database
     *
     * The database subjects
     */
    database?: Array<FirestoreProductSubject> | null;
    /**
     * Final
     *
     * The final keyword phrases
     */
    final?: Array<FirestoreProductSubject> | null;
    /**
     * Finalwords
     *
     * The final unique single words derived from keyword phrases
     */
    finalWords?: Array<FirestoreProductSubject> | null;
    /**
     * Bisac
     *
     * The BISAC subject headings
     */
    bisac?: Array<FirestoreProductBisacSubject>;
    [key: string]: unknown;
};

/**
 * FirestoreProductSubtitleCandidate
 */
export type FirestoreProductSubtitleCandidate = {
    /**
     * Subtitle
     */
    subtitle: string;
    /**
     * Reasoning
     */
    reasoning: string;
    /**
     * Isbestchoice
     */
    isBestChoice?: boolean | null;
    /**
     * Bestchoicereasoning
     */
    bestChoiceReasoning?: string | null;
};

/**
 * FirestoreProductSupplyDetail
 */
export type FirestoreProductSupplyDetail = {
    /**
     * Suppliername
     */
    supplierName?: string | null;
    /**
     * Supplierrole
     */
    supplierRole?: string | null;
    availability?: ProductAvailabilityNameLiteral;
};

/**
 * FirestoreUserApiKey
 */
export type FirestoreUserApiKey = {
    /**
     * Identifier
     */
    identifier: string;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Apikeyshort
     */
    apiKeyShort: string;
    /**
     * Createdat
     */
    createdAt: Date;
};

/**
 * GalleyBookResponse
 */
export type GalleyBookResponse = {
    document: Product;
    /**
     * Work Id
     */
    work_id?: string | null;
    /**
     * Same shape as the search hit's essence
     */
    essence?: GalleyEssenceSummary | null;
    essence_details?: GalleyEssenceDetails | null;
};

/**
 * GalleyCharacter
 */
export type GalleyCharacter = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Aliases
     */
    aliases?: Array<string>;
    /**
     * Role
     */
    role?: string | null;
    /**
     * Pronouns
     */
    pronouns?: string | null;
    /**
     * Age Label
     */
    age_label?: string | null;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * GalleyEssenceDetails
 */
export type GalleyEssenceDetails = {
    /**
     * Synopsis
     */
    synopsis?: string | null;
    /**
     * Settings
     */
    settings?: Array<GalleySetting>;
    /**
     * Characters
     */
    characters?: Array<GalleyCharacter>;
    /**
     * Trope Reasons
     */
    trope_reasons?: Array<string>;
    /**
     * Metaphysics
     */
    metaphysics?: string | null;
    /**
     * Metaphysics Description
     */
    metaphysics_description?: string | null;
    /**
     * Social Structure
     */
    social_structure?: string | null;
    /**
     * Social Structure Description
     */
    social_structure_description?: string | null;
};

/**
 * GalleyEssenceFilters
 */
export type GalleyEssenceFilters = {
    /**
     * Genres
     */
    genres?: Array<string>;
    /**
     * Tropes
     */
    tropes?: Array<string>;
    /**
     * Countries
     *
     * ISO 3166-1 alpha-2 codes, e.g. GB
     */
    countries?: Array<string>;
    /**
     * Cities
     */
    cities?: Array<string>;
    /**
     * Decades
     *
     * Decade start year, e.g. 1920
     */
    decades?: Array<number>;
    /**
     * Year From
     *
     * Keeps books whose setting period overlaps
     */
    year_from?: number | null;
    /**
     * Year To
     *
     * Keeps books whose setting period overlaps
     */
    year_to?: number | null;
    /**
     * Character Roles
     */
    character_roles?: Array<string>;
    /**
     * Protagonist Pronouns
     */
    protagonist_pronouns?: Array<string>;
};

/**
 * GalleyEssenceSummary
 */
export type GalleyEssenceSummary = {
    primary_setting?: GalleyPrimarySetting | null;
    /**
     * Genres
     */
    genres?: Array<string>;
    /**
     * Tropes
     */
    tropes?: Array<string>;
    /**
     * Countries
     */
    countries?: Array<string>;
    /**
     * Decades
     */
    decades?: Array<number>;
};

/**
 * GalleyPrimarySetting
 */
export type GalleyPrimarySetting = {
    /**
     * Label
     */
    label?: string | null;
    /**
     * Place
     */
    place?: string | null;
    /**
     * Period
     */
    period?: string | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * Country Name
     */
    country_name?: string | null;
    /**
     * Decades
     */
    decades?: Array<number>;
};

/**
 * GalleyProductFilters
 */
export type GalleyProductFilters = {
    published_by?: PublishedByFilter | null;
    product_group_description?: ProductGroupDescriptionFilter | null;
    published_at?: PublishedAtFilter | null;
};

/**
 * GalleyProject
 */
export type GalleyProject = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Created At
     */
    created_at: Date;
    /**
     * User Id
     */
    user_id: string;
    /**
     * Product Ids
     */
    product_ids: Array<string>;
    /**
     * Books
     *
     * In product_ids order; products that no longer exist in the organisation are left out
     */
    books: Array<GalleyProjectBook>;
};

/**
 * GalleyProjectBook
 */
export type GalleyProjectBook = {
    /**
     * Product Id
     */
    product_id: string;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Isbn
     */
    isbn?: string | null;
    /**
     * Format
     */
    format?: string | null;
    /**
     * Published At
     */
    published_at?: Date | null;
};

/**
 * GalleyProjectCreateRequest
 */
export type GalleyProjectCreateRequest = {
    /**
     * Name
     */
    name: string;
    /**
     * Product Ids
     *
     * Product ids of the organisation; duplicates are removed
     */
    product_ids: Array<string>;
};

/**
 * GalleySearchHit
 */
export type GalleySearchHit = {
    document: Product;
    /**
     * Score
     */
    score?: number | null;
    /**
     * Matched Queries
     */
    matched_queries?: Array<string>;
    /**
     * Work Id
     */
    work_id?: string | null;
    essence?: GalleyEssenceSummary | null;
    /**
     * Match Reasons
     *
     * Essence passages that best match the query
     */
    match_reasons?: Array<string>;
};

/**
 * GalleySearchRequest
 */
export type GalleySearchRequest = {
    /**
     * Query
     *
     * Empty query browses by newest publication date
     */
    query: string;
    /**
     * Page
     */
    page?: number;
    /**
     * Per Page
     */
    per_page?: number;
    filters?: GalleyProductFilters | null;
    essence_filters?: GalleyEssenceFilters | null;
    /**
     * Facets
     */
    facets?: Array<'publishers' | 'imprints' | 'productGroupDescription' | 'author' | 'genre' | 'keywords' | 'themaCodes' | 'bisacCodes' | 'essence.genres' | 'essence.tropes' | 'essence.countries' | 'essence.decades' | 'essence.characterRoles' | 'essence.protagonistPronouns'>;
};

/**
 * GalleySearchResponse
 */
export type GalleySearchResponse = {
    /**
     * Hits
     */
    hits: Array<GalleySearchHit>;
    /**
     * Found
     *
     * Distinct works found, one hit per work
     */
    found: number;
    /**
     * Took Ms
     */
    took_ms: number;
    /**
     * Page
     */
    page: number;
    /**
     * Per Page
     */
    per_page: number;
    /**
     * Aggregations
     */
    aggregations?: Array<AggregationBucket> | null;
};

/**
 * GalleySeasonalEvent
 */
export type GalleySeasonalEvent = {
    /**
     * Event Id
     */
    event_id: string;
    /**
     * Display Name
     */
    display_name: string;
    region: SeasonalEventRegion;
    /**
     * Start
     */
    start: Date;
    /**
     * End
     */
    end: Date;
    date_kind: SeasonalEventDateKind;
    /**
     * Days Until
     *
     * Negative while the event is ongoing
     */
    days_until: number;
    /**
     * Lead Time Months
     */
    lead_time_months: number;
    /**
     * Planning Starts
     *
     * start minus lead_time_months
     */
    planning_starts: Date;
    /**
     * Categories
     */
    categories?: Array<string>;
    /**
     * Description
     *
     * Why the event pipeline accepted the event
     */
    description?: string | null;
    /**
     * Evidence
     */
    evidence?: Array<string>;
    /**
     * Prompts
     */
    prompts?: Array<GalleySeasonalEventPrompt>;
};

/**
 * GalleySeasonalEventList
 */
export type GalleySeasonalEventList = {
    /**
     * Regions
     */
    regions: Array<SeasonalEventRegion>;
    /**
     * Window Start
     */
    window_start: Date;
    /**
     * Window End
     */
    window_end: Date;
    /**
     * Events
     */
    events: Array<GalleySeasonalEvent>;
};

/**
 * GalleySeasonalEventPrompt
 */
export type GalleySeasonalEventPrompt = {
    /**
     * Prompt Id
     */
    prompt_id: string;
    /**
     * Text
     */
    text: string;
};

/**
 * GalleySetting
 */
export type GalleySetting = {
    /**
     * Label
     */
    label?: string | null;
    /**
     * Place
     */
    place?: string | null;
    /**
     * Setting Type
     */
    setting_type?: string | null;
    /**
     * Period
     */
    period?: string | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * Region
     */
    region?: string | null;
    /**
     * Country Code
     */
    country_code?: string | null;
    /**
     * Country Name
     */
    country_name?: string | null;
    /**
     * Decades
     */
    decades?: Array<number>;
    /**
     * Year From
     */
    year_from?: number | null;
    /**
     * Year To
     */
    year_to?: number | null;
    /**
     * Setting Kind
     */
    setting_kind?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Is Primary
     */
    is_primary?: boolean;
};

/**
 * GenreFilter
 */
export type GenreFilter = {
    /**
     * Genres
     */
    genres: Array<string>;
};

/**
 * Granularity
 *
 * Time-bucket size for the sales series.
 */
export enum Granularity {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly'
}

/**
 * ImprintFilter
 */
export type ImprintFilter = {
    /**
     * Imprints
     */
    imprints: Array<string>;
};

/**
 * IsbnsFilter
 */
export type IsbnsFilter = {
    /**
     * Isbns
     */
    isbns: Array<string>;
};

/**
 * KeywordCountFilter
 */
export type KeywordCountFilter = {
    operator: FilterOperator;
    /**
     * Value
     */
    value: number;
};

/**
 * KeywordFeedbackCategory
 */
export enum KeywordFeedbackCategory {
    WRONG_ASSOCIATION = 'wrong_association',
    POOR_FIT = 'poor_fit',
    DUPLICATE_REDUNDANT = 'duplicate_redundant',
    OTHER = 'other'
}

/**
 * KeywordFeedbackDetails
 */
export type KeywordFeedbackDetails = {
    /**
     * Top-level category describing why the keyword is unsuitable
     */
    category: KeywordFeedbackCategory;
    /**
     * Sub-category within the chosen top-level category
     */
    subCategory?: KeywordFeedbackSubCategory | null;
    /**
     * Freetext
     *
     * Free-text reason, used when "Other" is selected
     */
    freeText?: string | null;
};

/**
 * KeywordFeedbackRequest
 */
export type KeywordFeedbackRequest = {
    /**
     * Keyword
     *
     * The keyword phrase the user is flagging
     */
    keyword: string;
    /**
     * Optional categorization. Omitted when only the thumbs-down is logged.
     */
    feedback?: KeywordFeedbackDetails | null;
    /**
     * Discarded
     *
     * When true, the document is marked as discarded by stamping discardedAt.
     */
    discarded?: boolean;
};

/**
 * KeywordFeedbackResponse
 */
export type KeywordFeedbackResponse = {
    /**
     * Id
     */
    id: string;
};

/**
 * KeywordFeedbackSubCategory
 */
export enum KeywordFeedbackSubCategory {
    INAPPROPRIATE = 'inappropriate',
    UNRELATED_REFERENCE = 'unrelated_reference',
    IRRELEVANT = 'irrelevant',
    TOO_SEASONAL = 'too_seasonal',
    TOO_GENERAL = 'too_general',
    REPEAT = 'repeat',
    METADATA_REFERENCE = 'metadata_reference',
    OTHER = 'other'
}

/**
 * KeywordsFilter
 */
export type KeywordsFilter = {
    /**
     * Keywords
     */
    keywords: Array<string>;
};

/**
 * ManuscriptUploadRequest
 *
 * Request model for uploading just a manuscript with minimal product data
 */
export type ManuscriptUploadRequest = {
    /**
     * Manuscript
     *
     * The manuscript file (PDF or DOCX, required)
     */
    manuscript: Blob | File;
};

/**
 * OnixExportStatus
 */
export enum OnixExportStatus {
    REQUESTED = 'REQUESTED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR'
}

/**
 * OnixImportReportErrorResponse
 */
export type OnixImportReportErrorResponse = {
    /**
     * Error
     *
     * Error message describing what went wrong
     */
    error: string;
    /**
     * Code
     *
     * HTTP error status code
     */
    code: number;
};

/**
 * OnixImportReportScheduleRequest
 */
export type OnixImportReportScheduleRequest = {
    /**
     * Oniximportreportid
     *
     * The ID of the ONIX import report to export
     */
    onixImportReportId: string;
};

/**
 * OnixImportReportScheduleResponse
 */
export type OnixImportReportScheduleResponse = {
    /**
     * Exportid
     *
     * The unique identifier for the export request
     */
    exportId: string;
};

/**
 * OrganisationShort
 */
export type OrganisationShort = {
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
};

/**
 * OrganisationUserCreateRequest
 */
export type OrganisationUserCreateRequest = {
    /**
     * Email
     */
    email: string;
    role: UserRole;
};

/**
 * OrganisationUsersCreateRequest
 */
export type OrganisationUsersCreateRequest = {
    /**
     * Users
     */
    users?: Array<OrganisationUserCreateRequest>;
};

export enum ProductAvailabilityCodeLiteral {
    _01 = '01',
    _09 = '09',
    _10 = '10',
    _11 = '11',
    _12 = '12',
    _20 = '20',
    _21 = '21',
    _22 = '22',
    _23 = '23',
    _30 = '30',
    _31 = '31',
    _32 = '32',
    _33 = '33',
    _34 = '34',
    _40 = '40',
    _41 = '41',
    _42 = '42',
    _43 = '43',
    _44 = '44',
    _45 = '45',
    _46 = '46',
    _47 = '47',
    _48 = '48',
    _49 = '49',
    _50 = '50',
    _51 = '51',
    _52 = '52',
    _97 = '97',
    _98 = '98',
    _99 = '99'
}

export enum ProductAvailabilityNameLiteral {
    CANCELLED = 'Cancelled',
    NOT_YET_AVAILABLE_POSTPONED_INDEFINITELY = 'Not_yet_available_postponed_indefinitely',
    NOT_YET_AVAILABLE = 'Not_yet_available',
    AWAITING_STOCK = 'Awaiting_stock',
    NOT_YET_AVAILABLE_WILL_BE_POD = 'Not_yet_available_will_be_POD',
    AVAILABLE = 'Available',
    IN_STOCK = 'In_stock',
    TO_ORDER = 'To_order',
    POD = 'POD',
    TEMPORARILY_UNAVAILABLE = 'Temporarily_unavailable',
    OUT_OF_STOCK = 'Out_of_stock',
    REPRINTING = 'Reprinting',
    AWAITING_REISSUE = 'Awaiting_reissue',
    TEMPORARILY_WITHDRAWN_FROM_SALE = 'Temporarily_withdrawn_from_sale',
    NOT_AVAILABLE_REASON_UNSPECIFIED = 'Not_available_reason_unspecified',
    NOT_AVAILABLE_REPLACED_BY_NEW_PRODUCT = 'Not_available_replaced_by_new_product',
    NOT_AVAILABLE_OTHER_FORMAT_AVAILABLE = 'Not_available_other_format_available',
    NO_LONGER_SUPPLIED_BY_THE_SUPPLIER = 'No_longer_supplied_by_the_supplier',
    APPLY_DIRECT = 'Apply_direct',
    NOT_SOLD_SEPARATELY = 'Not_sold_separately',
    WITHDRAWN_FROM_SALE = 'Withdrawn_from_sale',
    REMAINDERED = 'Remaindered',
    NOT_AVAILABLE_REPLACED_BY_POD = 'Not_available_replaced_by_POD',
    RECALLED = 'Recalled',
    NOT_SOLD_AS_SET = 'Not_sold_as_set',
    NOT_AVAILABLE_PUBLISHER_INDICATES_OP = 'Not_available_publisher_indicates_OP',
    NOT_AVAILABLE_PUBLISHER_NO_LONGER_SELLS_PRODUCT_IN_THIS_MARKET = 'Not_available_publisher_no_longer_sells_product_in_this_market',
    NO_RECENT_UPDATE_RECEIVED = 'No_recent_update_received',
    NO_LONGER_RECEIVING_UPDATES = 'No_longer_receiving_updates',
    CONTACT_SUPPLIER = 'Contact_supplier'
}

export enum ProductFormCodeLiteral {
    _00 = '00',
    AA = 'AA',
    AB = 'AB',
    AC = 'AC',
    AD = 'AD',
    AE = 'AE',
    AF = 'AF',
    AG = 'AG',
    AH = 'AH',
    AI = 'AI',
    AJ = 'AJ',
    AK = 'AK',
    AL = 'AL',
    AM = 'AM',
    AN = 'AN',
    AO = 'AO',
    AZ = 'AZ',
    BA = 'BA',
    BB = 'BB',
    BC = 'BC',
    BD = 'BD',
    BE = 'BE',
    BF = 'BF',
    BG = 'BG',
    BH = 'BH',
    BI = 'BI',
    BJ = 'BJ',
    BK = 'BK',
    BL = 'BL',
    BM = 'BM',
    BN = 'BN',
    BO = 'BO',
    BP = 'BP',
    BZ = 'BZ',
    CA = 'CA',
    CB = 'CB',
    CC = 'CC',
    CD = 'CD',
    CE = 'CE',
    CZ = 'CZ',
    DA = 'DA',
    DB = 'DB',
    DC = 'DC',
    DE = 'DE',
    DF = 'DF',
    DI = 'DI',
    DJ = 'DJ',
    DK = 'DK',
    DL = 'DL',
    DM = 'DM',
    DN = 'DN',
    DO = 'DO',
    DZ = 'DZ',
    EA = 'EA',
    EB = 'EB',
    EC = 'EC',
    ED = 'ED',
    FA = 'FA',
    FC = 'FC',
    FD = 'FD',
    FE = 'FE',
    FF = 'FF',
    FZ = 'FZ',
    LA = 'LA',
    LB = 'LB',
    LC = 'LC',
    MA = 'MA',
    MB = 'MB',
    MC = 'MC',
    MZ = 'MZ',
    PA = 'PA',
    PB = 'PB',
    PC = 'PC',
    PD = 'PD',
    PE = 'PE',
    PF = 'PF',
    PG = 'PG',
    PH = 'PH',
    PI = 'PI',
    PJ = 'PJ',
    PK = 'PK',
    PL = 'PL',
    PM = 'PM',
    PN = 'PN',
    PO = 'PO',
    PP = 'PP',
    PQ = 'PQ',
    PR = 'PR',
    PS = 'PS',
    PT = 'PT',
    PU = 'PU',
    PV = 'PV',
    PZ = 'PZ',
    SA = 'SA',
    SB = 'SB',
    SC = 'SC',
    SD = 'SD',
    SE = 'SE',
    SF = 'SF',
    SG = 'SG',
    VA = 'VA',
    VF = 'VF',
    VI = 'VI',
    VJ = 'VJ',
    VK = 'VK',
    VL = 'VL',
    VM = 'VM',
    VN = 'VN',
    VO = 'VO',
    VP = 'VP',
    VQ = 'VQ',
    VZ = 'VZ',
    XA = 'XA',
    XB = 'XB',
    XC = 'XC',
    XD = 'XD',
    XE = 'XE',
    XF = 'XF',
    XG = 'XG',
    XH = 'XH',
    XI = 'XI',
    XJ = 'XJ',
    XK = 'XK',
    XL = 'XL',
    XM = 'XM',
    XN = 'XN',
    XO = 'XO',
    XY = 'XY',
    XZ = 'XZ',
    ZA = 'ZA',
    ZB = 'ZB',
    ZC = 'ZC',
    ZD = 'ZD',
    ZE = 'ZE',
    ZF = 'ZF',
    ZG = 'ZG',
    ZH = 'ZH',
    ZI = 'ZI',
    ZJ = 'ZJ',
    ZK = 'ZK',
    ZL = 'ZL',
    ZM = 'ZM',
    ZN = 'ZN',
    ZO = 'ZO',
    ZP = 'ZP',
    ZX = 'ZX',
    ZY = 'ZY',
    ZZ = 'ZZ'
}

export enum ProductFormDescLiteral {
    UNDEFINED = 'Undefined',
    AUDIO = 'Audio',
    AUDIO_CASSETTE = 'Audio cassette',
    CD_AUDIO = 'CD-Audio',
    DAT = 'DAT',
    AUDIO_DISC = 'Audio disc',
    AUDIO_TAPE = 'Audio tape',
    MINI_DISC = 'MiniDisc',
    CD_EXTRA = 'CD-Extra',
    DVD_AUDIO = 'DVD Audio',
    DOWNLOADABLE_AUDIO_FILE = 'Downloadable audio file',
    PRE_RECORDED_DIGITAL_AUDIO_PLAYER = 'Pre-recorded digital audio player',
    PRE_RECORDED_SD_CARD = 'Pre-recorded SD card',
    LP = 'LP',
    DOWNLOADABLE_AND_ONLINE_AUDIO_FILE = 'Downloadable and online audio file',
    ONLINE_AUDIO_FILE = 'Online audio file',
    OTHER_AUDIO_FORMAT = 'Other audio format',
    BOOK = 'Book',
    HARDBACK = 'Hardback',
    PAPERBACK_SOFTBACK = 'Paperback / softback',
    LOOSE_LEAF = 'Loose-leaf',
    SPIRAL_BOUND = 'Spiral bound',
    PAMPHLET = 'Pamphlet',
    LEATHER_FINE_BINDING = 'Leather / fine binding',
    BOARD_BOOK = 'Board book',
    RAG_BOOK = 'Rag book',
    BATH_BOOK = 'Bath book',
    NOVELTY_BOOK = 'Novelty book',
    SLIDE_BOUND = 'Slide bound',
    BIG_BOOK = 'Big book',
    PART_WORK_FASCÍCULO = 'Part-work (fascículo)',
    FOLD_OUT_BOOK_OR_CHART = 'Fold-out book or chart',
    FOAM_BOOK = 'Foam book',
    OTHER_BOOK_FORMAT = 'Other book format',
    SHEET_MAP = 'Sheet map',
    'SHEET_MAP,_FOLDED' = 'Sheet map, folded',
    'SHEET_MAP,_FLAT' = 'Sheet map, flat',
    'SHEET_MAP,_ROLLED' = 'Sheet map, rolled',
    GLOBE = 'Globe',
    OTHER_CARTOGRAPHIC = 'Other cartographic',
    DIGITAL_ON_PHYSICAL_CARRIER = 'Digital (on physical carrier)',
    CD_ROM = 'CD-ROM',
    CD_I = 'CD-I',
    GAME_CARTRIDGE = 'Game cartridge',
    DISKETTE = 'Diskette',
    DVD_ROM = 'DVD-ROM',
    SECURE_DIGITAL_SD_MEMORY_CARD = 'Secure Digital (SD) Memory Card',
    COMPACT_FLASH_MEMORY_CARD = 'Compact Flash Memory Card',
    MEMORY_STICK_MEMORY_CARD = 'Memory Stick Memory Card',
    USB_FLASH_DRIVE = 'USB Flash Drive',
    DOUBLE_SIDED_CD_DVD = 'Double-sided CD/DVD',
    BR_ROM = 'BR-ROM',
    OTHER_DIGITAL_CARRIER = 'Other digital carrier',
    DIGITAL_DELIVERED_ELECTRONICALLY = 'Digital (delivered electronically)',
    DIGITAL_DOWNLOAD_AND_ONLINE = 'Digital download and online',
    DIGITAL_ONLINE = 'Digital online',
    DIGITAL_DOWNLOAD = 'Digital download',
    FILM_OR_TRANSPARENCY = 'Film or transparency',
    SLIDES = 'Slides',
    OHP_TRANSPARENCIES = 'OHP transparencies',
    FILMSTRIP = 'Filmstrip',
    FILM = 'Film',
    OTHER_FILM_OR_TRANSPARENCY_FORMAT = 'Other film or transparency format',
    DIGITAL_PRODUCT_LICENSE = 'Digital product license',
    DIGITAL_PRODUCT_LICENSE_KEY = 'Digital product license key',
    DIGITAL_PRODUCT_LICENSE_CODE = 'Digital product license code',
    MICROFORM = 'Microform',
    MICROFICHE = 'Microfiche',
    MICROFILM = 'Microfilm',
    OTHER_MICROFORM = 'Other microform',
    MISCELLANEOUS_PRINT = 'Miscellaneous print',
    ADDRESS_BOOK = 'Address book',
    CALENDAR = 'Calendar',
    CARDS = 'Cards',
    COPYMASTERS = 'Copymasters',
    DIARY_OR_JOURNAL = 'Diary or journal',
    FRIEZE = 'Frieze',
    KIT = 'Kit',
    SHEET_MUSIC = 'Sheet music',
    POSTCARD_BOOK_OR_PACK = 'Postcard book or pack',
    POSTER = 'Poster',
    RECORD_BOOK = 'Record book',
    WALLET_OR_FOLDER = 'Wallet or folder',
    PICTURES_OR_PHOTOGRAPHS = 'Pictures or photographs',
    WALLCHART = 'Wallchart',
    STICKERS = 'Stickers',
    PLATE_LÁMINA = 'Plate (lámina)',
    NOTEBOOK_BLANK_BOOK = 'Notebook / blank book',
    ORGANIZER = 'Organizer',
    BOOKMARK = 'Bookmark',
    LEAFLET = 'Leaflet',
    BOOK_PLATES = 'Book plates',
    OTHER_PRINTED_ITEM = 'Other printed item',
    MULTIPLE_COMPONENT_RETAIL_PRODUCT = 'Multiple-component retail product',
    'MULTIPLE_COMPONENT_RETAIL_PRODUCT,_BOXED' = 'Multiple-component retail product, boxed',
    'MULTIPLE_COMPONENT_RETAIL_PRODUCT,_SLIP_CASED' = 'Multiple-component retail product, slip-cased',
    'MULTIPLE_COMPONENT_RETAIL_PRODUCT,_SHRINK_WRAPPED' = 'Multiple-component retail product, shrink-wrapped',
    'MULTIPLE_COMPONENT_RETAIL_PRODUCT,_LOOSE' = 'Multiple-component retail product, loose',
    'MULTIPLE_COMPONENT_RETAIL_PRODUCT,_PART_S_ENCLOSED' = 'Multiple-component retail product, part(s) enclosed',
    'MULTIPLE_COMPONENT_RETAIL_PRODUCT,_ENTIRELY_DIGITAL' = 'Multiple-component retail product, entirely digital',
    VIDEO = 'Video',
    VIDEODISC = 'Videodisc',
    DVD_VIDEO = 'DVD video',
    VHS_VIDEO = 'VHS video',
    BETAMAX_VIDEO = 'Betamax video',
    VCD = 'VCD',
    SVCD = 'SVCD',
    HD_DVD = 'HD DVD',
    BLU_RAY = 'Blu-ray',
    UMD_VIDEO = 'UMD Video',
    CBHD = 'CBHD',
    OTHER_VIDEO_FORMAT = 'Other video format',
    TRADE_ONLY_MATERIAL = 'Trade-only material',
    'DUMPBIN –_EMPTY' = 'Dumpbin – empty',
    'DUMPBIN –_FILLED' = 'Dumpbin – filled',
    'COUNTERPACK –_EMPTY' = 'Counterpack – empty',
    'COUNTERPACK –_FILLED' = 'Counterpack – filled',
    'POSTER,_PROMOTIONAL' = 'Poster, promotional',
    SHELF_STRIP = 'Shelf strip',
    WINDOW_PIECE = 'Window piece',
    STREAMER = 'Streamer',
    'SPINNER –_EMPTY' = 'Spinner – empty',
    LARGE_BOOK_DISPLAY = 'Large book display',
    SHRINK_WRAPPED_PACK = 'Shrink-wrapped pack',
    BOXED_PACK = 'Boxed pack',
    PACK_OUTER_PACKAGING_UNSPECIFIED = 'Pack (outer packaging unspecified)',
    'SPINNER –_FILLED' = 'Spinner – filled',
    'OTHER_POINT_OF_SALE –_INCLUDING_RETAIL_PRODUCT' = 'Other point of sale – including retail product',
    OTHER_POINT_OF_SALE = 'Other point of sale',
    GENERAL_MERCHANDISE = 'General merchandise',
    DOLL_OR_FIGURE = 'Doll or figure',
    SOFT_TOY = 'Soft toy',
    TOY = 'Toy',
    GAME = 'Game',
    T_SHIRT = 'T-shirt',
    E_BOOK_READER = 'E-book reader',
    TABLET_COMPUTER = 'Tablet computer',
    AUDIOBOOK_PLAYER = 'Audiobook player',
    JIGSAW = 'Jigsaw',
    MUG = 'Mug',
    TOTE_BAG = 'Tote bag',
    TABLEWARE = 'Tableware',
    UMBRELLA = 'Umbrella',
    'PAINTS,_CRAYONS,_PENCILS' = 'Paints, crayons, pencils',
    HANDICRAFT_KIT = 'Handicraft kit',
    OTHER_TOY_GAME_ACCESSORIES = 'Other toy/game accessories',
    OTHER_APPAREL = 'Other apparel',
    OTHER_MERCHANDISE = 'Other merchandise'
}

/**
 * Product
 *
 * Excludes internal fields like organisationId and embedding source text.
 */
export type Product = {
    /**
     * Id
     */
    id: string;
    /**
     * Identifier
     */
    identifier: string;
    /**
     * Title
     */
    title: string;
    /**
     * Author
     */
    author?: Array<string>;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Publishers
     */
    publishers?: Array<string>;
    /**
     * Imprints
     */
    imprints?: Array<string>;
    /**
     * Productgroupdescription
     */
    productGroupDescription?: string;
    /**
     * Genre
     */
    genre?: Array<string>;
    /**
     * Keywords
     */
    keywords?: Array<string>;
    /**
     * Themacodes
     */
    themaCodes?: Array<string>;
    /**
     * Publishedat
     */
    publishedAt?: Date | null;
    /**
     * Keywordcount
     */
    keywordCount?: number;
    /**
     * Descriptionlength
     */
    descriptionLength?: number;
    /**
     * Themacodecount
     */
    themaCodeCount?: number;
    /**
     * Workid
     */
    workId?: string | null;
    /**
     * Identifiers
     */
    identifiers?: Array<FirestoreProductIdentifier>;
    dimensions?: FirestoreProductDimensions | null;
    images?: FirestoreProductImages;
    /**
     * Quotes
     */
    quotes?: Array<FirestoreProductQuote>;
    /**
     * Seriesids
     */
    seriesIds?: Array<string>;
    series?: FirestoreProductSeries;
    /**
     * Createdat
     */
    createdAt?: Date | null;
    /**
     * Updatedat
     */
    updatedAt?: Date | null;
};

/**
 * ProductAPlusPageSummary
 */
export type ProductAPlusPageSummary = {
    /**
     * None when every A+ page that is not a draft was built by hand.
     */
    generation: APlusGenerationSummary | null;
};

/**
 * ProductAcpFeedPreviewResponse
 */
export type ProductAcpFeedPreviewResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Is Eligible Search
     */
    is_eligible_search: boolean;
    /**
     * Is Eligible Checkout
     */
    is_eligible_checkout: boolean;
    acp_product: AcpProduct;
};

/**
 * ProductAmplifyAPlusContentResponse
 *
 * A+ content status for a product, as reported by Amplify.
 *
 * Both URLs are null unless there is something to link to. See
 * docs/amplify-integration.md.
 */
export type ProductAmplifyAPlusContentResponse = {
    status: APlusContentStatus;
    /**
     * Amazonurl
     *
     * Amazon detail page the A+ content is published to
     */
    amazonUrl: string | null;
    /**
     * Amplifyurl
     *
     * Amplify page where the A+ content is managed
     */
    amplifyUrl: string | null;
    /**
     * Modules
     *
     * A+ module types aggregated from APPROVED pages
     */
    modules: Array<APlusContentModule>;
};

/**
 * ProductAmplifySummary
 *
 * A product as Amplify reports it. See docs/amplify-integration.md.
 */
export type ProductAmplifySummary = {
    /**
     * Id
     */
    id: string;
    /**
     * Amplify's A+ page summary. None when the product has no A+ pages.
     */
    aPlusPage: ProductAPlusPageSummary | null;
};

/**
 * ProductCreationResponse
 */
export type ProductCreationResponse = {
    /**
     * Id
     *
     * The id of the created product
     */
    id: string;
    /**
     * Manuscriptfilename
     *
     * The filename of the uploaded manuscript
     */
    manuscriptFilename?: string | null;
};

/**
 * ProductDeletionResponse
 */
export type ProductDeletionResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Success
     */
    success: boolean;
    /**
     * Message
     */
    message: string;
};

/**
 * ProductGenerationRequestDescription
 */
export type ProductGenerationRequestDescription = {
    /**
     * Hash
     */
    hash?: string | null;
    /**
     * Specialrequest
     */
    specialRequest?: string | null;
    /**
     * Targetgroup
     */
    targetGroup?: string | null;
};

/**
 * ProductGenerationRequestDescriptionBulk
 */
export type ProductGenerationRequestDescriptionBulk = {
    /**
     * Specialrequest
     */
    specialRequest?: string | null;
    /**
     * Targetgroup
     */
    targetGroup?: string | null;
    /**
     * Identifiers
     *
     * A list of products to generate keywords for
     */
    identifiers: Array<string>;
    /**
     * Filters
     *
     * A list of filters to apply to the products descriptions.
     */
    filters?: Array<ProductGenerationRequestDescriptionBulkFilter>;
};

/**
 * ProductGenerationRequestDescriptionBulkFilter
 */
export type ProductGenerationRequestDescriptionBulkFilter = {
    /**
     * Texttype
     *
     * The type of text to filter on
     */
    textType?: string | null;
    /**
     * Audience
     *
     * The audience to filter on
     */
    audience?: string | null;
};

/**
 * ProductGenerationRequestKeywords
 */
export type ProductGenerationRequestKeywords = {
    /**
     * Generate
     */
    generate?: boolean;
    /**
     * Forcegenerate
     */
    forceGenerate?: boolean;
    /**
     * Rank
     */
    rank?: boolean;
    /**
     * Autofill
     */
    autoFill?: boolean;
};

/**
 * ProductGenerationRequestKeywordsBulk
 */
export type ProductGenerationRequestKeywordsBulk = {
    /**
     * Generate
     */
    generate?: boolean;
    /**
     * Forcegenerate
     */
    forceGenerate?: boolean;
    /**
     * Rank
     */
    rank?: boolean;
    /**
     * Autofill
     */
    autoFill?: boolean;
    /**
     * Identifiers
     *
     * A list of products to generate keywords for
     */
    identifiers: Array<string>;
};

/**
 * ProductGenerationRequestManuscript
 */
export type ProductGenerationRequestManuscript = {
    [key: string]: unknown;
};

/**
 * ProductGenerationRequestSubtitle
 */
export type ProductGenerationRequestSubtitle = {
    /**
     * Specialrequest
     *
     * Special request for subtitle generation
     */
    specialRequest?: string | null;
};

/**
 * ProductGenerationRequestThemaBulk
 */
export type ProductGenerationRequestThemaBulk = {
    /**
     * Identifiers
     *
     * A list of products to generate thema for
     */
    identifiers: Array<string>;
};

/**
 * ProductGenerationResponse
 */
export type ProductGenerationResponse = {
    /**
     * Generationrequestid
     *
     * The id of the generation request
     */
    generationRequestId: string;
};

/**
 * ProductGenerationResponseBulk
 */
export type ProductGenerationResponseBulk = {
    /**
     * Generationrequestids
     *
     * The ids of the generation requests
     */
    generationRequestIds: Array<string>;
    /**
     * Failedrequests
     *
     * List of failed product requests with productId and reason for failure
     */
    failedRequests?: Array<FailedRequestInfo>;
};

/**
 * ProductGroupDescriptionFilter
 */
export type ProductGroupDescriptionFilter = {
    /**
     * Productgroupdescriptions
     */
    productGroupDescriptions: Array<string>;
};

/**
 * ProductIdsFilter
 */
export type ProductIdsFilter = {
    /**
     * Product Ids
     */
    product_ids: Array<string>;
};

/**
 * ProductRawResponse
 */
export type ProductRawResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Header
     */
    header?: {
        [key: string]: unknown;
    };
    /**
     * Baseproduct
     */
    baseProduct?: {
        [key: string]: unknown;
    };
    /**
     * Rawonixv3
     */
    rawOnixV3?: {
        [key: string]: unknown;
    };
};

/**
 * ProductResponse
 */
export type ProductResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Identifier
     */
    identifier: string;
    /**
     * Identifiertype
     */
    identifierType?: string | null;
    /**
     * Identifiers
     */
    identifiers?: Array<FirestoreProductIdentifier>;
    /**
     * Workid
     */
    workId?: string | null;
    importData?: FirestoreProductImportData | null;
    /**
     * Title
     */
    title: string;
    /**
     * Descriptions
     */
    descriptions?: Array<FirestoreProductDescription> | null;
    /**
     * Subtitles
     */
    subtitles?: Array<FirestoreProductSubtitleCandidate>;
    /**
     * Biography
     */
    biography?: string | null;
    /**
     * Author
     */
    author?: Array<string>;
    /**
     * Genre
     */
    genre?: Array<string>;
    /**
     * Keywordcount
     */
    keywordCount?: number;
    /**
     * Language
     */
    language: string;
    /**
     * Languageoriginal
     */
    languageOriginal: string;
    organisation: OrganisationShort;
    productGroup: ProductFormCodeLiteral;
    productGroupDescription: ProductFormDescLiteral;
    /**
     * Publisher
     */
    publisher: string;
    /**
     * Publishers
     */
    publishers?: Array<FirestoreProductPublisher>;
    /**
     * Imprints
     */
    imprints?: Array<string>;
    /**
     * Publishedat
     */
    publishedAt: Date | null;
    /**
     * Createdat
     */
    createdAt: Date;
    /**
     * Updatedat
     */
    updatedAt: Date;
    subjects?: FirestoreProductSubjects | null;
    /**
     * Forcesynctriggeredat
     */
    forceSyncTriggeredAt?: Date | null;
    categorization?: FirestoreProductCategorization | null;
    sourceType?: ProductSource;
    manuscript?: FirestoreProductManuscript | null;
    actions?: FirestoreProductActions;
    /**
     * Iseligiblesearch
     */
    isEligibleSearch?: boolean;
    /**
     * Iseligiblecheckout
     */
    isEligibleCheckout?: boolean;
    /**
     * Supplydetails
     */
    supplyDetails?: Array<FirestoreProductSupplyDetail>;
    dimensions?: FirestoreProductDimensions | null;
    ageRanges?: FirestoreProductAgeRanges | null;
    images?: FirestoreProductImages;
    /**
     * Quotes
     */
    quotes?: Array<FirestoreProductQuote>;
    series?: FirestoreProductSeries;
};

/**
 * ProductSearchFilters
 */
export type ProductSearchFilters = {
    keyword_count?: KeywordCountFilter | null;
    description_length?: DescriptionLengthFilter | null;
    description_word_count?: DescriptionWordCountFilter | null;
    thema_code_count?: ThemaCodeCountFilter | null;
    bisac_code_count?: BisacCodeCountFilter | null;
    published_at?: PublishedAtFilter | null;
    published_by?: PublishedByFilter | null;
    imprint?: ImprintFilter | null;
    isbns?: IsbnsFilter | null;
    series_ids?: SeriesIdsFilter | null;
    product_ids?: ProductIdsFilter | null;
    product_group_description?: ProductGroupDescriptionFilter | null;
    author?: AuthorFilter | null;
    genre?: GenreFilter | null;
    keywords?: KeywordsFilter | null;
    thema_codes?: ThemaCodesFilter | null;
    bisac_codes?: BisacCodesFilter | null;
    sales_metrics?: SalesMetricsFilter | null;
    age_range?: AgeRangeFilter | null;
};

/**
 * ProductSearchHit
 */
export type ProductSearchHit = {
    document: Product;
    /**
     * Score
     */
    score?: number | null;
    /**
     * Matched Queries
     */
    matched_queries?: Array<string>;
};

/**
 * ProductSearchRequest
 */
export type ProductSearchRequest = {
    /**
     * Query
     */
    query: string;
    /**
     * Use Semantic
     */
    use_semantic?: boolean;
    /**
     * Use Hybrid
     */
    use_hybrid?: boolean;
    /**
     * Page
     */
    page?: number;
    /**
     * Per Page
     */
    per_page?: number;
    filters?: ProductSearchFilters | null;
    /**
     * Aggregations
     */
    aggregations?: Array<string> | null;
    /**
     * Aggregation Query
     */
    aggregation_query?: string | null;
    /**
     * Aggregation Size
     */
    aggregation_size?: number | null;
    /**
     * Include Age Range Bounds
     */
    include_age_range_bounds?: boolean;
};

/**
 * ProductSearchResponse
 */
export type ProductSearchResponse = {
    /**
     * Hits
     */
    hits: Array<ProductSearchHit>;
    /**
     * Found
     */
    found: number;
    /**
     * Took Ms
     */
    took_ms: number;
    /**
     * Page
     */
    page: number;
    /**
     * Per Page
     */
    per_page: number;
    /**
     * Aggregations
     */
    aggregations?: Array<AggregationBucket> | null;
    age_range_available_bounds?: AgeRangeAvailableBounds | null;
};

/**
 * ProductSearchSalesMetricCriterion
 */
export type ProductSearchSalesMetricCriterion = {
    metric: SalesSearchMetric;
    operator: FilterOperator;
    /**
     * Value
     */
    value: number | string;
};

/**
 * ProductSource
 */
export enum ProductSource {
    ONIX_IMPORT = 'ONIX_IMPORT',
    MANUSCRIPT_ONLY = 'MANUSCRIPT_ONLY'
}

/**
 * ProductsAmplifySummariesRequest
 */
export type ProductsAmplifySummariesRequest = {
    /**
     * Productids
     *
     * Products to summarise
     */
    productIds: Array<string>;
};

/**
 * ProductsAmplifySummariesResponse
 */
export type ProductsAmplifySummariesResponse = {
    /**
     * Products
     *
     * One summary per requested product, in request order
     */
    products: Array<ProductAmplifySummary>;
};

/**
 * ProductsCsvExportRequest
 */
export type ProductsCsvExportRequest = {
    /**
     * Identifiers
     *
     * A list of product identifiers to export as CSV
     */
    identifiers: Array<string>;
    /**
     * Audience
     *
     * The audience to filter descriptions by (e.g., 'Booktrade', 'End_customers')
     */
    audience?: string | null;
    /**
     * Texttype
     *
     * The type of text to filter descriptions by (e.g., 'Description', 'Annotation')
     */
    textType?: string | null;
};

/**
 * ProductsExportRequest
 */
export type ProductsExportRequest = {
    /**
     * Productids
     *
     * A list of products to export
     */
    productIds: Array<string>;
};

/**
 * ProductsExportResponse
 */
export type ProductsExportResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Productids
     */
    productIds?: Array<string>;
    status: OnixExportStatus;
    /**
     * Downloadurl
     */
    downloadUrl?: string | null;
};

/**
 * ProjectAmplifyProductsRequest
 */
export type ProjectAmplifyProductsRequest = {
    /**
     * Productids
     *
     * Product ids of the project to add to its Amplify project
     */
    productIds: Array<string>;
};

/**
 * ProjectAmplifyProductsResponse
 */
export type ProjectAmplifyProductsResponse = {
    /**
     * Amplifyprojectid
     *
     * Id of the project in Amplify
     */
    amplifyProjectId: string;
    /**
     * Addedcount
     *
     * Number of products that were not in the Amplify project yet
     */
    addedCount: number;
};

/**
 * PublishedAtFilter
 */
export type PublishedAtFilter = {
    /**
     * Gte
     */
    gte: Date;
    /**
     * Lte
     */
    lte: Date;
};

/**
 * PublishedByFilter
 */
export type PublishedByFilter = {
    /**
     * Publishers
     */
    publishers: Array<string>;
};

/**
 * SalesInfoResponse
 *
 * Window-independent sales metadata for the selected book(s): the earliest
 * sale date per source, the data-freshness signal, and the markets the book
 * has sold into. Everything here is computed over all history so the client
 * can anchor the date picker, the pre-order banner, and a stable market order.
 *
 * `market` is the first `sales_market` (industry panel) date across the
 * selected ISBNs; `amazon` is the first Amazon ordered-sales date for the
 * primary ISBN (pre-orders included). Both are ISO dates (YYYY-MM-DD) or null
 * when the source has no rows.
 */
export type SalesInfoResponse = {
    /**
     * Market
     */
    market: string | null;
    /**
     * Amazon
     */
    amazon: string | null;
    /**
     * Lastsyncedat
     */
    lastSyncedAt: string | null;
    /**
     * Markets
     */
    markets: Array<string>;
};

/**
 * SalesMetricsFilter
 */
export type SalesMetricsFilter = {
    /**
     * Start
     */
    start?: Date | null;
    /**
     * End
     */
    end?: Date | null;
    /**
     * Criteria
     */
    criteria: Array<ProductSearchSalesMetricCriterion>;
};

/**
 * SalesResponse
 *
 * Unified `GET /books/sales` contract, discriminated by the `type` field:
 * `market` yields `BookSalesResponse`, `amazon` yields `AmazonSalesResponse`.
 */
export type SalesResponse = ({
    type: 'market';
} & BookSalesResponse) | ({
    type: 'amazon';
} & AmazonSalesResponse);

/**
 * SalesSearchMetric
 */
export enum SalesSearchMetric {
    TOTAL_UNITS = 'total_units',
    AMAZON_ORDERED_UNITS = 'amazon_ordered_units',
    AMAZON_CONVERSION_RATE = 'amazon_conversion_rate'
}

/**
 * SeasonalEventDateKind
 */
export enum SeasonalEventDateKind {
    ACTUAL = 'actual',
    OBSERVED = 'observed',
    CAMPAIGN = 'campaign'
}

/**
 * SeasonalEventRegion
 */
export enum SeasonalEventRegion {
    US = 'us',
    UK = 'uk',
    DE = 'de',
    AUS = 'aus',
    INTERNATIONAL = 'international'
}

/**
 * SeriesIdsFilter
 */
export type SeriesIdsFilter = {
    /**
     * Series Ids
     */
    series_ids: Array<string>;
};

/**
 * SeriesLevel
 */
export enum SeriesLevel {
    COLLECTION = 'collection',
    SUBCOLLECTION = 'subcollection'
}

/**
 * SeriesNumberSource
 */
export enum SeriesNumberSource {
    COLLECTION_SEQUENCE = 'collection_sequence',
    PART_NUMBER = 'part_number'
}

/**
 * SeriesOrderType
 *
 * ONIX List 197 (collection sequence type).
 */
export enum SeriesOrderType {
    PROPRIETARY = 'proprietary',
    TITLE_ORDER = 'title_order',
    PUBLICATION_ORDER = 'publication_order',
    TEMPORAL_NARRATIVE_ORDER = 'temporal_narrative_order',
    ORIGINAL_PUBLICATION_ORDER = 'original_publication_order',
    SUGGESTED_READING_ORDER = 'suggested_reading_order',
    SUGGESTED_DISPLAY_ORDER = 'suggested_display_order'
}

/**
 * SeriesStatus
 */
export enum SeriesStatus {
    IN_SERIES = 'in_series',
    NOT_IN_SERIES = 'not_in_series',
    UNKNOWN = 'unknown'
}

/**
 * SubjectSource
 */
export enum SubjectSource {
    GENERATED = 'GENERATED',
    DATABASE = 'DATABASE',
    MANUAL = 'MANUAL'
}

/**
 * ThemaCode
 *
 * Model for a Thema-Code.
 */
export type ThemaCode = {
    /**
     * Id
     */
    id: string;
    /**
     * Code
     */
    code: string;
    /**
     * Description
     */
    description: string;
    type: ThemaCodeType;
    /**
     * Notes
     */
    notes?: string | null;
    /**
     * Parent
     */
    parent?: string | null;
    /**
     * Has Children
     */
    has_children?: boolean;
    /**
     * Level
     */
    level?: number;
    /**
     * Children Length
     */
    children_length?: number;
    /**
     * Highlighted Code
     */
    highlighted_code?: string | null;
    /**
     * Highlighted Description
     */
    highlighted_description?: string | null;
    /**
     * Highlighted Notes
     */
    highlighted_notes?: string | null;
};

/**
 * ThemaCodeCountFilter
 */
export type ThemaCodeCountFilter = {
    operator: FilterOperator;
    /**
     * Value
     */
    value: number;
};

/**
 * ThemaCodeType
 *
 * Type of Thema-Code.
 */
export enum ThemaCodeType {
    SUBJECT = 'subject',
    QUALIFIER = 'qualifier'
}

/**
 * ThemaCodesFilter
 */
export type ThemaCodesFilter = {
    /**
     * Codes
     */
    codes: Array<string>;
};

/**
 * ThemaCodesResponse
 *
 * Response model for THEMA hierarchy navigation (/thema/codes).
 */
export type ThemaCodesResponse = {
    /**
     * Codes
     */
    codes: Array<ThemaCode>;
    /**
     * Root Code
     */
    root_code?: string | null;
};

/**
 * ThemaSearchResponse
 *
 * Response model for THEMA search (/thema/search).
 */
export type ThemaSearchResponse = {
    /**
     * Codes
     */
    codes: Array<ThemaCode>;
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number;
    /**
     * Per Page
     */
    per_page: number;
    /**
     * Took Ms
     */
    took_ms: number;
};

/**
 * UpdateFinalKeywordsRequest
 */
export type UpdateFinalKeywordsRequest = {
    /**
     * Subjects
     *
     * The final keyword subjects to save
     */
    subjects: Array<FirestoreProductSubject>;
};

/**
 * UserProfile
 */
export type UserProfile = {
    /**
     * Firstname
     */
    firstName: string;
    /**
     * Lastname
     */
    lastName: string;
    /**
     * Photourl
     */
    photoURL?: string | null;
};

/**
 * UserResponse
 */
export type UserResponse = {
    /**
     * Id
     */
    id: string;
    /**
     * Userid
     */
    userId: string;
    /**
     * Email
     */
    email: string;
    /**
     * Emailverified
     */
    emailVerified?: boolean;
    /**
     * Givenname
     */
    givenName?: string | null;
    /**
     * Familyname
     */
    familyName?: string | null;
    organisation?: OrganisationShort | null;
    /**
     * Apikeys
     */
    apiKeys?: Array<FirestoreUserApiKey> | null;
    /**
     * Roles
     */
    roles?: Array<UserRole> | null;
    /**
     * Deletedat
     */
    deletedAt?: Date | null;
};

/**
 * UserRole
 */
export enum UserRole {
    SUPER_ADMIN = 'SUPER_ADMIN',
    ADMIN = 'ADMIN',
    MEMBER = 'MEMBER'
}

/**
 * V1MetadataBlurbRequest
 */
export type V1MetadataBlurbRequest = {
    /**
     * Inputtext
     *
     * The main text to be used for metadata generation
     */
    inputText: string;
    /**
     * Language
     *
     * The language of the text
     */
    language?: string | null;
    /**
     * Theme
     *
     * Theme of the text
     */
    theme?: string | null;
    /**
     * Title
     *
     * Title of the text
     */
    title?: string | null;
    /**
     * Author
     *
     * List of text authors
     */
    author?: Array<string> | null;
    /**
     * Publisher
     *
     * Publisher of the text
     */
    publisher?: string | null;
    /**
     * Format
     *
     * Onix product form code. See the full list here https://onix-codelists.io/codelist/150
     */
    format?: Array<ProductFormCodeLiteral> | null;
    /**
     * Genre
     *
     * List of genres of the text
     */
    genre?: Array<string> | null;
    /**
     * Keywords
     *
     * List of existing keywords of the text
     */
    keywords?: Array<string> | null;
    /**
     * Specialrequest
     *
     * Special request to be included in the generation
     */
    specialRequest?: string | null;
    /**
     * Targetgroup
     *
     * Group of people the text is targeted to
     */
    targetGroup?: string | null;
    /**
     * Targetgroupbook
     *
     * Group of people the book is targeted to
     */
    targetGroupBook?: string | null;
    /**
     * Maxlength
     *
     * Maximum length of the generated text
     */
    maxLength?: number | null;
    /**
     * Additionaldata
     *
     * Additional arbitrary data to attach to the request for later retrieval
     */
    additionalData?: unknown | null;
    /**
     * Callbackurl
     *
     * Callback URL to be called when the generation is finished. The HTTP method will be POST and the data sent will be the same as the response route
     */
    callbackUrl?: string | null;
    /**
     * Callbackauthheader
     *
     * In case the callback URL requires authentication, the header to be sent as 'Authorization' to the callback URL. Although not mandatory it is highly recommended to use it.
     */
    callbackAuthHeader?: string | null;
    /**
     * Clientid
     *
     * The identifier of the client that made the request
     */
    clientId: string;
    /**
     * Isbn
     *
     * The ISBN of the book that the metadata is being generated for
     */
    isbn: string;
};

/**
 * V1MetadataBlurbResponse
 */
export type V1MetadataBlurbResponse = {
    /**
     * Generation Finished
     *
     * A boolean stating if the generation process has finished.
     */
    generation_finished: boolean;
    /**
     * Message
     *
     * Descriptive message describing the status of generation process
     */
    message?: string | null;
    metadata: V1MetadataBlurbResponseData;
};

/**
 * V1MetadataBlurbResponseData
 */
export type V1MetadataBlurbResponseData = {
    /**
     * Identifier
     *
     * The identifier of the generation request
     */
    identifier: string;
    /**
     * Generatedtext
     *
     * Generated text
     */
    generatedText: string;
    /**
     * Clientid
     *
     * The identifier of the client that made the request
     */
    clientId: string;
    /**
     * Isbn
     *
     * The ISBN of the book that the metadata is being generated for
     */
    isbn: string;
};

/**
 * V1MetadataKeywordRequest
 */
export type V1MetadataKeywordRequest = {
    /**
     * Inputtext
     *
     * The main text to be used for metadata generation
     */
    inputText: string;
    /**
     * Language
     *
     * The language of the text
     */
    language?: string | null;
    /**
     * Theme
     *
     * Theme of the text
     */
    theme?: string | null;
    /**
     * Title
     *
     * Title of the text
     */
    title?: string | null;
    /**
     * Author
     *
     * List of text authors
     */
    author?: Array<string> | null;
    /**
     * Publisher
     *
     * Publisher of the text
     */
    publisher?: string | null;
    /**
     * Format
     *
     * Onix product form code. See the full list here https://onix-codelists.io/codelist/150
     */
    format?: Array<ProductFormCodeLiteral> | null;
    /**
     * Genre
     *
     * List of genres of the text
     */
    genre?: Array<string> | null;
    /**
     * Keywords
     *
     * List of existing keywords of the text
     */
    keywords?: Array<string> | null;
    /**
     * Specialrequest
     *
     * Special request to be included in the generation
     */
    specialRequest?: string | null;
    /**
     * Targetgroup
     *
     * Group of people the text is targeted to
     */
    targetGroup?: string | null;
    /**
     * Targetgroupbook
     *
     * Group of people the book is targeted to
     */
    targetGroupBook?: string | null;
    /**
     * Maxlength
     *
     * Maximum length of the generated text
     */
    maxLength?: number | null;
    /**
     * Additionaldata
     *
     * Additional arbitrary data to attach to the request for later retrieval
     */
    additionalData?: unknown | null;
    /**
     * Callbackurl
     *
     * Callback URL to be called when the generation is finished. The HTTP method will be POST and the data sent will be the same as the response route
     */
    callbackUrl?: string | null;
    /**
     * Callbackauthheader
     *
     * In case the callback URL requires authentication, the header to be sent as 'Authorization' to the callback URL. Although not mandatory it is highly recommended to use it.
     */
    callbackAuthHeader?: string | null;
    /**
     * Clientid
     *
     * The identifier of the client that made the request
     */
    clientId: string;
    /**
     * Isbn
     *
     * The ISBN of the book that the metadata is being generated for
     */
    isbn: string;
};

/**
 * V1MetadataKeywordResponse
 */
export type V1MetadataKeywordResponse = {
    /**
     * Generation Finished
     *
     * A boolean stating if the generation process has finished.
     */
    generation_finished: boolean;
    /**
     * Message
     *
     * Descriptive message describing the status of generation process
     */
    message?: string | null;
    metadata: V1MetadataKeywordResponseData;
};

/**
 * V1MetadataKeywordResponseData
 */
export type V1MetadataKeywordResponseData = {
    /**
     * Identifier
     *
     * The identifier of the generation request
     */
    identifier: string;
    /**
     * Generatedkeywords
     *
     * The list of generated keywords
     */
    generatedKeywords: Array<string>;
    /**
     * Clientid
     *
     * The identifier of the client that made the request
     */
    clientId: string;
    /**
     * Isbn
     *
     * The ISBN of the book that the metadata is being generated for
     */
    isbn: string;
};

/**
 * ValidationErrorDetail
 */
export type ValidationErrorDetail = {
    /**
     * Loc
     */
    loc: Array<unknown>;
    /**
     * Type
     */
    type: string;
    /**
     * Msg
     */
    msg: string;
};

export type HealthData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/health';
};

export type HealthResponses = {
    /**
     * Success
     */
    200: ApiResponseApiResponseMessageStatus200;
};

export type HealthResponse = HealthResponses[keyof HealthResponses];

export type ProductsSearchData = {
    body?: ProductSearchRequest;
    path?: never;
    query?: never;
    url: '/search/products';
};

export type ProductsSearchErrors = {
    /**
     * The search request is invalid.
     */
    400: ApiResponseApiResponseMessageStatus400;
    /**
     * Sales data is not enabled for this user or organisation.
     */
    403: ApiResponseApiResponseMessageStatus403;
    /**
     * The product search failed.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type ProductsSearchError = ProductsSearchErrors[keyof ProductsSearchErrors];

export type ProductsSearchResponses = {
    /**
     * Success
     */
    200: ApiResponseProductSearchResponseStatus200;
};

export type ProductsSearchResponse = ProductsSearchResponses[keyof ProductsSearchResponses];

export type GetThemaCodesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Type of Thema-Code: 'subject' or 'qualifier' (default: 'subject')
         */
        type?: string;
        /**
         * Parent Thema-Code to get children for. If omitted, returns root codes.
         */
        parent?: string;
        /**
         * Language code for THEMA data (default: 'en')
         */
        language?: string;
    };
    url: '/thema/codes';
};

export type GetThemaCodesResponses = {
    /**
     * Success
     */
    200: ApiResponseThemaCodesResponseStatus200;
};

export type GetThemaCodesResponse = GetThemaCodesResponses[keyof GetThemaCodesResponses];

export type SearchThemaData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Search query string
         */
        q: string;
        /**
         * Type of Thema-Code to search: 'subject' or 'qualifier' (default: 'subject')
         */
        type?: string;
        /**
         * Page number for pagination (default: 1)
         */
        page?: number;
        /**
         * Number of results per page (default: 20, max: 100)
         */
        per_page?: number;
        /**
         * Language code for THEMA data (default: 'en')
         */
        language?: string;
    };
    url: '/thema/search';
};

export type SearchThemaResponses = {
    /**
     * Success
     */
    200: ApiResponseThemaSearchResponseStatus200;
};

export type SearchThemaResponse = SearchThemaResponses[keyof SearchThemaResponses];

export type GetBisacCodesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/bisac/codes';
};

export type GetBisacCodesErrors = {
    /**
     * The BISAC catalogue is not available.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type GetBisacCodesError = GetBisacCodesErrors[keyof GetBisacCodesErrors];

export type GetBisacCodesResponses = {
    /**
     * Success
     */
    200: ApiResponseBisacCodesResponseStatus200;
};

export type GetBisacCodesResponse = GetBisacCodesResponses[keyof GetBisacCodesResponses];

export type SearchBisacData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Code prefix or heading terms
         */
        q: string;
    };
    url: '/bisac/search';
};

export type SearchBisacErrors = {
    /**
     * The query is missing or too long.
     */
    400: ApiResponseApiResponseMessageStatus400;
    /**
     * The BISAC catalogue is not available.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type SearchBisacError = SearchBisacErrors[keyof SearchBisacErrors];

export type SearchBisacResponses = {
    /**
     * Success
     */
    200: ApiResponseBisacSearchResponseStatus200;
};

export type SearchBisacResponse = SearchBisacResponses[keyof SearchBisacResponses];

export type GetOrganisationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/account/organisations';
};

export type GetOrganisationsResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountOrganisationsResponseStatus200;
};

export type GetOrganisationsResponse = GetOrganisationsResponses[keyof GetOrganisationsResponses];

export type DeleteOrganisationData = {
    body?: never;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}';
};

export type DeleteOrganisationResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountOrganisationResponseStatus200;
};

export type DeleteOrganisationResponse = DeleteOrganisationResponses[keyof DeleteOrganisationResponses];

export type GetOrganisationData = {
    body?: never;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}';
};

export type GetOrganisationResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountOrganisationResponseStatus200;
};

export type GetOrganisationResponse = GetOrganisationResponses[keyof GetOrganisationResponses];

export type PatchOrganisationData = {
    body?: AccountOrganisationUpdateRequest;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}';
};

export type PatchOrganisationResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountOrganisationResponseStatus200;
};

export type PatchOrganisationResponse = PatchOrganisationResponses[keyof PatchOrganisationResponses];

export type PostChildOrganisationData = {
    body?: AccountOrganisationCreateRequest;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}';
};

export type PostChildOrganisationResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountOrganisationResponseStatus200;
};

export type PostChildOrganisationResponse = PostChildOrganisationResponses[keyof PostChildOrganisationResponses];

export type UndeleteOrganisationData = {
    body?: never;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/undelete';
};

export type UndeleteOrganisationResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountOrganisationResponseStatus200;
};

export type UndeleteOrganisationResponse = UndeleteOrganisationResponses[keyof UndeleteOrganisationResponses];

export type PostOrganisationData = {
    body?: AccountOrganisationCreateRequest;
    path?: never;
    query?: never;
    url: '/account/organisation';
};

export type PostOrganisationResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountOrganisationResponseStatus200;
};

export type PostOrganisationResponse = PostOrganisationResponses[keyof PostOrganisationResponses];

export type UpdateOrganisationSettingsData = {
    body?: AccountOrganisationSettingsUpdateRequest;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/settings';
};

export type UpdateOrganisationSettingsResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountOrganisationResponseStatus200;
};

export type UpdateOrganisationSettingsResponse = UpdateOrganisationSettingsResponses[keyof UpdateOrganisationSettingsResponses];

export type GetOrganisationsUsersData = {
    body?: never;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/users';
};

export type GetOrganisationsUsersResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountUsersResponseStatus200;
};

export type GetOrganisationsUsersResponse = GetOrganisationsUsersResponses[keyof GetOrganisationsUsersResponses];

export type AddOrganisationUsersData = {
    body?: OrganisationUsersCreateRequest;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/users';
};

export type AddOrganisationUsersResponses = {
    /**
     * Success
     */
    200: ApiResponseApiResponseMessageStatus200;
};

export type AddOrganisationUsersResponse = AddOrganisationUsersResponses[keyof AddOrganisationUsersResponses];

export type PostUserData = {
    body?: AccountUserCreateRequest;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/user';
};

export type PostUserResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountUserResponseStatus200;
};

export type PostUserResponse = PostUserResponses[keyof PostUserResponses];

export type DeleteOrganisationUserData = {
    body?: never;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
        /**
         * The identifier of the user
         */
        useridentifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/user/{useridentifier}';
};

export type DeleteOrganisationUserResponses = {
    /**
     * Success
     */
    200: ApiResponseApiResponseMessageStatus200;
};

export type DeleteOrganisationUserResponse = DeleteOrganisationUserResponses[keyof DeleteOrganisationUserResponses];

export type GetOrganisationUserData = {
    body?: never;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
        /**
         * The identifier of the user
         */
        useridentifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/user/{useridentifier}';
};

export type GetOrganisationUserResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountUserResponseStatus200;
};

export type GetOrganisationUserResponse = GetOrganisationUserResponses[keyof GetOrganisationUserResponses];

export type PatchUserData = {
    body?: AccountUserUpdateRequest;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
        /**
         * The identifier of the user
         */
        useridentifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/user/{useridentifier}';
};

export type PatchUserResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountUserResponseStatus200;
};

export type PatchUserResponse = PatchUserResponses[keyof PatchUserResponses];

export type TransferUserOrganisationData = {
    body?: never;
    path: {
        /**
         * The identifier of the source organisation
         */
        source_id: string;
        /**
         * The identifier of the user
         */
        useridentifier: string;
        /**
         * The identifier of the destination organisation
         */
        destination_id: string;
    };
    query?: never;
    url: '/account/organisation/{source_id}/user/{useridentifier}/transfer/{destination_id}';
};

export type TransferUserOrganisationResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountUserResponseStatus200;
};

export type TransferUserOrganisationResponse = TransferUserOrganisationResponses[keyof TransferUserOrganisationResponses];

export type GetOrganisationUserApiKeysData = {
    body?: never;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
        /**
         * The identifier of the user
         */
        useridentifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/user/{useridentifier}/api-keys';
};

export type GetOrganisationUserApiKeysResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountUserApiKeysResponseStatus200;
};

export type GetOrganisationUserApiKeysResponse = GetOrganisationUserApiKeysResponses[keyof GetOrganisationUserApiKeysResponses];

export type PostOrganisationUserApiKeyData = {
    body?: AccountUserApiKeyRequest;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
        /**
         * The identifier of the user
         */
        useridentifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/user/{useridentifier}/api-key';
};

export type PostOrganisationUserApiKeyResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountUserApiKeyCreatedResponseStatus200;
};

export type PostOrganisationUserApiKeyResponse = PostOrganisationUserApiKeyResponses[keyof PostOrganisationUserApiKeyResponses];

export type DeleteOrganisationUsersApiKeyData = {
    body?: never;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
        /**
         * The identifier of the user
         */
        useridentifier: string;
        /**
         * The identifier of the api key
         */
        apikeyidentifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/user/{useridentifier}/api-key/{apikeyidentifier}';
};

export type DeleteOrganisationUsersApiKeyResponses = {
    /**
     * Success
     */
    200: ApiResponseApiResponseMessageStatus200;
};

export type DeleteOrganisationUsersApiKeyResponse = DeleteOrganisationUsersApiKeyResponses[keyof DeleteOrganisationUsersApiKeyResponses];

export type PostOrganisationFileRouteData = {
    body?: AccountOrganisationFileRequest;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
        /**
         * The file name
         */
        file_name: string;
    };
    query?: {
        /**
         * Whether to sign the file or not
         */
        no_sign?: boolean;
    };
    url: '/account/organisation/{identifier}/file/{file_name}';
};

export type PostOrganisationFileRouteResponses = {
    /**
     * Success
     */
    200: ApiResponseAccountOrganisationFileResponseStatus200;
};

export type PostOrganisationFileRouteResponse = PostOrganisationFileRouteResponses[keyof PostOrganisationFileRouteResponses];

export type PostAcpExportData = {
    body?: AcpExportRequest;
    path: {
        /**
         * The identifier of the organisation
         */
        identifier: string;
    };
    query?: never;
    url: '/account/organisation/{identifier}/acp-export';
};

export type PostAcpExportErrors = {
    /**
     * The organisation was not found.
     */
    404: ApiResponseApiResponseMessageStatus404;
    /**
     * Failed to start the ACP export task.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type PostAcpExportError = PostAcpExportErrors[keyof PostAcpExportErrors];

export type PostAcpExportResponses = {
    /**
     * Success
     */
    202: AcpExportResponse;
};

export type PostAcpExportResponse = PostAcpExportResponses[keyof PostAcpExportResponses];

export type GetEvaluationsListData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/evaluations';
};

export type GetEvaluationsListResponses = {
    /**
     * Success
     */
    200: ApiResponseEvaluationsResponseStatus200;
};

export type GetEvaluationsListResponse = GetEvaluationsListResponses[keyof GetEvaluationsListResponses];

export type PostEvaluationData = {
    body?: EvaluationRequest;
    path?: never;
    query?: never;
    url: '/evaluation';
};

export type PostEvaluationResponses = {
    /**
     * Success
     */
    200: ApiResponseEvaluationResponseStatus200;
};

export type PostEvaluationResponse = PostEvaluationResponses[keyof PostEvaluationResponses];

export type GetEvaluationData = {
    body?: never;
    path: {
        /**
         * The identifier of the evaluation entry
         */
        identifier: string;
    };
    query?: never;
    url: '/evaluation/{identifier}';
};

export type GetEvaluationResponses = {
    /**
     * Success
     */
    200: ApiResponseEvaluationResponseStatus200;
};

export type GetEvaluationResponse = GetEvaluationResponses[keyof GetEvaluationResponses];

export type CancelEvaluationData = {
    body?: never;
    path: {
        /**
         * The identifier of the evaluation entry
         */
        identifier: string;
    };
    query?: never;
    url: '/evaluation/{identifier}/cancel';
};

export type CancelEvaluationResponses = {
    /**
     * Success
     */
    200: ApiResponseApiResponseMessageStatus200;
};

export type CancelEvaluationResponse = CancelEvaluationResponses[keyof CancelEvaluationResponses];

export type GetProductRawData = {
    body?: never;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}/raw';
};

export type GetProductRawErrors = {
    /**
     * The product was not found or has no import data.
     */
    404: ApiResponseApiResponseMessageStatus404;
};

export type GetProductRawError = GetProductRawErrors[keyof GetProductRawErrors];

export type GetProductRawResponses = {
    /**
     * Success
     */
    200: ApiResponseProductRawResponseStatus200;
};

export type GetProductRawResponse = GetProductRawResponses[keyof GetProductRawResponses];

export type GetProductAcpFeedPreviewData = {
    body?: never;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}/acp-feed-preview';
};

export type GetProductAcpFeedPreviewErrors = {
    /**
     * Product or required import data not found.
     */
    404: ApiResponseApiResponseMessageStatus404;
    /**
     * Failed to generate ACP feed preview.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type GetProductAcpFeedPreviewError = GetProductAcpFeedPreviewErrors[keyof GetProductAcpFeedPreviewErrors];

export type GetProductAcpFeedPreviewResponses = {
    /**
     * Success
     */
    200: ApiResponseProductAcpFeedPreviewResponseStatus200;
};

export type GetProductAcpFeedPreviewResponse = GetProductAcpFeedPreviewResponses[keyof GetProductAcpFeedPreviewResponses];

export type GetProductAmplifyAPlusContentData = {
    body?: never;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}/amplify/a-plus-content';
};

export type GetProductAmplifyAPlusContentErrors = {
    /**
     * A+ content is not enabled for the user.
     */
    403: ApiResponseApiResponseMessageStatus403;
    /**
     * The product was not found.
     */
    404: ApiResponseApiResponseMessageStatus404;
    /**
     * No Amplify API key is configured for the organisation.
     */
    500: ApiResponseApiResponseMessageStatus500;
    /**
     * Amplify did not return a usable A+ content status.
     */
    502: ApiResponseApiResponseMessageStatus502;
};

export type GetProductAmplifyAPlusContentError = GetProductAmplifyAPlusContentErrors[keyof GetProductAmplifyAPlusContentErrors];

export type GetProductAmplifyAPlusContentResponses = {
    /**
     * Success
     */
    200: ApiResponseProductAmplifyAPlusContentResponseStatus200;
};

export type GetProductAmplifyAPlusContentResponse = GetProductAmplifyAPlusContentResponses[keyof GetProductAmplifyAPlusContentResponses];

export type ListProductsAmplifySummariesData = {
    body?: ProductsAmplifySummariesRequest;
    path?: never;
    query?: never;
    url: '/products/amplify/summaries';
};

export type ListProductsAmplifySummariesErrors = {
    /**
     * A+ content is not enabled for the user.
     */
    403: ApiResponseApiResponseMessageStatus403;
    /**
     * No Amplify API key is configured for the organisation.
     */
    500: ApiResponseApiResponseMessageStatus500;
    /**
     * Amplify did not return usable summaries.
     */
    502: ApiResponseApiResponseMessageStatus502;
};

export type ListProductsAmplifySummariesError = ListProductsAmplifySummariesErrors[keyof ListProductsAmplifySummariesErrors];

export type ListProductsAmplifySummariesResponses = {
    /**
     * Success
     */
    200: ApiResponseProductsAmplifySummariesResponseStatus200;
};

export type ListProductsAmplifySummariesResponse = ListProductsAmplifySummariesResponses[keyof ListProductsAmplifySummariesResponses];

export type GenerateProductKeywordsData = {
    body?: ProductGenerationRequestKeywords;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}/generation/keywords';
};

export type GenerateProductKeywordsResponses = {
    /**
     * Success
     */
    200: ApiResponseProductGenerationResponseStatus200;
};

export type GenerateProductKeywordsResponse = GenerateProductKeywordsResponses[keyof GenerateProductKeywordsResponses];

export type GenerateProductKeywordsBulkData = {
    body?: ProductGenerationRequestKeywordsBulk;
    path?: never;
    query?: never;
    url: '/products/generation/keywords';
};

export type GenerateProductKeywordsBulkResponses = {
    /**
     * Success
     */
    200: ApiResponseProductGenerationResponseBulkStatus200;
};

export type GenerateProductKeywordsBulkResponse = GenerateProductKeywordsBulkResponses[keyof GenerateProductKeywordsBulkResponses];

export type GenerateProductDescriptionData = {
    body?: ProductGenerationRequestDescription;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}/generation/description';
};

export type GenerateProductDescriptionResponses = {
    /**
     * Success
     */
    200: ApiResponseProductGenerationResponseStatus200;
};

export type GenerateProductDescriptionResponse = GenerateProductDescriptionResponses[keyof GenerateProductDescriptionResponses];

export type GenerateProductDescriptionBulkData = {
    body?: ProductGenerationRequestDescriptionBulk;
    path?: never;
    query?: never;
    url: '/products/generation/description';
};

export type GenerateProductDescriptionBulkResponses = {
    /**
     * Success
     */
    200: ApiResponseProductGenerationResponseBulkStatus200;
};

export type GenerateProductDescriptionBulkResponse = GenerateProductDescriptionBulkResponses[keyof GenerateProductDescriptionBulkResponses];

export type GenerateProductThemaData = {
    body?: never;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}/generation/thema';
};

export type GenerateProductThemaResponses = {
    /**
     * Success
     */
    200: ApiResponseProductGenerationResponseStatus200;
};

export type GenerateProductThemaResponse = GenerateProductThemaResponses[keyof GenerateProductThemaResponses];

export type GenerateProductThemaBulkData = {
    body?: ProductGenerationRequestThemaBulk;
    path?: never;
    query?: never;
    url: '/products/generation/thema';
};

export type GenerateProductThemaBulkResponses = {
    /**
     * Success
     */
    200: ApiResponseProductGenerationResponseBulkStatus200;
};

export type GenerateProductThemaBulkResponse = GenerateProductThemaBulkResponses[keyof GenerateProductThemaBulkResponses];

export type GenerateProductSubtitleData = {
    body?: ProductGenerationRequestSubtitle;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}/generation/subtitle';
};

export type GenerateProductSubtitleResponses = {
    /**
     * Success
     */
    200: ApiResponseProductGenerationResponseStatus200;
};

export type GenerateProductSubtitleResponse = GenerateProductSubtitleResponses[keyof GenerateProductSubtitleResponses];

export type GenerateProductManuscriptAnalysisData = {
    body?: ProductGenerationRequestManuscript;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}/generation/analysis';
};

export type GenerateProductManuscriptAnalysisErrors = {
    /**
     * Manuscript upload is not enabled for the user.
     */
    403: ApiResponseApiResponseMessageStatus403;
};

export type GenerateProductManuscriptAnalysisError = GenerateProductManuscriptAnalysisErrors[keyof GenerateProductManuscriptAnalysisErrors];

export type GenerateProductManuscriptAnalysisResponses = {
    /**
     * Success
     */
    200: ApiResponseProductGenerationResponseStatus200;
};

export type GenerateProductManuscriptAnalysisResponse = GenerateProductManuscriptAnalysisResponses[keyof GenerateProductManuscriptAnalysisResponses];

export type ExportProductsData = {
    body?: ProductsExportRequest;
    path?: never;
    query?: never;
    url: '/products/export';
};

export type ExportProductsResponses = {
    /**
     * Success
     */
    200: ApiResponseProductsExportResponseStatus200;
};

export type ExportProductsResponse = ExportProductsResponses[keyof ExportProductsResponses];

export type ExportOrganizationBooksCsvData = {
    body?: ProductsCsvExportRequest;
    path?: never;
    query?: never;
    url: '/products/export-csv';
};

export type ExportOrganizationBooksCsvErrors = {
    /**
     * The export request is invalid or contains no exportable products.
     */
    400: ApiResponseApiResponseMessageStatus400;
    /**
     * One or more requested products were not found.
     */
    404: ApiResponseApiResponseMessageStatus404;
    /**
     * Failed to generate the CSV export.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type ExportOrganizationBooksCsvError = ExportOrganizationBooksCsvErrors[keyof ExportOrganizationBooksCsvErrors];

export type ExportOrganizationBooksCsvResponses = {
    /**
     * CSV file containing the requested books
     */
    200: string;
};

export type ExportOrganizationBooksCsvResponse = ExportOrganizationBooksCsvResponses[keyof ExportOrganizationBooksCsvResponses];

export type CreateProductFromManuscriptData = {
    body?: ManuscriptUploadRequest;
    path?: never;
    query?: never;
    url: '/product/manuscript-upload';
};

export type CreateProductFromManuscriptErrors = {
    /**
     * Manuscript upload is not enabled for the user.
     */
    403: ApiResponseApiResponseMessageStatus403;
};

export type CreateProductFromManuscriptError = CreateProductFromManuscriptErrors[keyof CreateProductFromManuscriptErrors];

export type CreateProductFromManuscriptResponses = {
    /**
     * Success
     */
    200: ApiResponseProductCreationResponseStatus200;
};

export type CreateProductFromManuscriptResponse = CreateProductFromManuscriptResponses[keyof CreateProductFromManuscriptResponses];

export type DeleteProductData = {
    body?: never;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}';
};

export type DeleteProductErrors = {
    /**
     * Manuscript upload is not enabled for the user.
     */
    403: ApiResponseApiResponseMessageStatus403;
};

export type DeleteProductError = DeleteProductErrors[keyof DeleteProductErrors];

export type DeleteProductResponses = {
    /**
     * Success
     */
    200: ApiResponseProductDeletionResponseStatus200;
};

export type DeleteProductResponse = DeleteProductResponses[keyof DeleteProductResponses];

export type UpdateProductFinalKeywordsData = {
    body?: UpdateFinalKeywordsRequest;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/product/{product_id}/keywords/final';
};

export type UpdateProductFinalKeywordsResponses = {
    /**
     * Keywords updated successfully
     */
    204: void;
};

export type UpdateProductFinalKeywordsResponse = UpdateProductFinalKeywordsResponses[keyof UpdateProductFinalKeywordsResponses];

export type UpsertProductKeywordFeedbackData = {
    body?: KeywordFeedbackRequest;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
        /**
         * Client-generated UUID identifying the feedback document
         */
        feedback_id: string;
    };
    query?: never;
    url: '/product/{product_id}/keywords/feedback/{feedback_id}';
};

export type UpsertProductKeywordFeedbackResponses = {
    /**
     * Feedback updated
     */
    200: ApiResponseKeywordFeedbackResponseStatus200;
    /**
     * Feedback created
     */
    201: ApiResponseKeywordFeedbackResponseStatus201;
};

export type UpsertProductKeywordFeedbackResponse = UpsertProductKeywordFeedbackResponses[keyof UpsertProductKeywordFeedbackResponses];

export type AddProjectProductsToAmplifyData = {
    body?: ProjectAmplifyProductsRequest;
    path: {
        /**
         * The Reedy project id
         */
        project_id: string;
    };
    query?: never;
    url: '/projects/{project_id}/amplify/products';
};

export type AddProjectProductsToAmplifyErrors = {
    /**
     * A product is not in the project.
     */
    400: ApiResponseApiResponseMessageStatus400;
    /**
     * Amplify projects are not enabled for the user.
     */
    403: ApiResponseApiResponseMessageStatus403;
    /**
     * The project was not found.
     */
    404: ApiResponseApiResponseMessageStatus404;
    /**
     * The request failed validation.
     */
    422: ApiResponseApiResponseValidationErrorStatus422;
    /**
     * No Amplify API key is configured for the organisation.
     */
    500: ApiResponseApiResponseMessageStatus500;
    /**
     * Amplify did not add the products.
     */
    502: ApiResponseApiResponseMessageStatus502;
};

export type AddProjectProductsToAmplifyError = AddProjectProductsToAmplifyErrors[keyof AddProjectProductsToAmplifyErrors];

export type AddProjectProductsToAmplifyResponses = {
    /**
     * Success
     */
    200: ApiResponseProjectAmplifyProductsResponseStatus200;
};

export type AddProjectProductsToAmplifyResponse = AddProjectProductsToAmplifyResponses[keyof AddProjectProductsToAmplifyResponses];

export type GetUserData = {
    body?: never;
    path: {
        /**
         * The identifier of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}';
};

export type GetUserResponses = {
    /**
     * Success
     */
    200: ApiResponseUserProfileStatus200;
};

export type GetUserResponse = GetUserResponses[keyof GetUserResponses];

export type GenerateLoginLinkData = {
    body?: never;
    path: {
        /**
         * The identifier of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/users/{user_id}/login-link';
};

export type GenerateLoginLinkResponses = {
    /**
     * Success
     */
    200: ApiResponseApiResponseMessageStatus200;
};

export type GenerateLoginLinkResponse = GenerateLoginLinkResponses[keyof GenerateLoginLinkResponses];

export type GetFileData = {
    body?: never;
    path: {
        /**
         * The type of the file e.g. ONIX_IMPORT
         */
        file_type: 'ACP_EXPORT' | 'EVALUATION_REPORT' | 'MANUAL_ONIX_IMPORT' | 'MANUSCRIPT' | 'MANUSCRIPT_VERSION' | 'ONIX_CHUNK' | 'ONIX_EXPORT' | 'ONIX_IMPORT' | 'ONIX_IMPORT_REPORT' | 'TREND' | 'UNKNOWN';
        /**
         * The file path of the file to be retrieved
         */
        file_name: string;
    };
    query?: never;
    url: '/files/{file_type}/{file_name}';
};

export type GetFileResponses = {
    /**
     * Success
     */
    200: Blob | File;
};

export type GetFileResponse = GetFileResponses[keyof GetFileResponses];

export type PostOnixImportReportScheduleData = {
    body?: OnixImportReportScheduleRequest;
    path?: never;
    query?: never;
    url: '/reports/onix-imports';
};

export type PostOnixImportReportScheduleErrors = {
    /**
     * The request body is invalid.
     */
    400: OnixImportReportErrorResponse;
    /**
     * The caller is not authenticated.
     */
    401: ApiResponseApiResponseMessageStatus401;
    /**
     * Failed to schedule the export task.
     */
    500: OnixImportReportErrorResponse;
};

export type PostOnixImportReportScheduleError = PostOnixImportReportScheduleErrors[keyof PostOnixImportReportScheduleErrors];

export type PostOnixImportReportScheduleResponses = {
    /**
     * Success
     */
    202: OnixImportReportScheduleResponse;
};

export type PostOnixImportReportScheduleResponse = PostOnixImportReportScheduleResponses[keyof PostOnixImportReportScheduleResponses];

export type GetBookSalesRouteData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Comma-separated or repeated ISBN-13 / GTIN values to query. The first value is the selected book; remaining values are additional selected ISBNs to aggregate for bundled `type=market` and `type=amazon` reads.
         */
        isbns: string;
        /**
         * Inclusive start of the window, ISO date (YYYY-MM-DD).
         */
        start: string;
        /**
         * Inclusive end of the window, ISO date (YYYY-MM-DD).
         */
        end: string;
        /**
         * Preferred bucket size: daily | weekly | monthly. If it doesn't fit the range it is clamped to the coarsest available option; the response's `range.granularity` reports the effective value and `range.availableGranularities` lists every valid option.
         */
        granularity: string;
        /**
         * Sales source: market (default) | amazon.
         */
        type?: 'market' | 'amazon';
    };
    url: '/books/sales';
};

export type GetBookSalesRouteErrors = {
    /**
     * The request parameters are missing or invalid.
     */
    400: ApiResponseApiResponseMessageStatus400;
    /**
     * Sales data is not enabled for the user or the organisation's salesDataLake is DISABLED.
     */
    403: ApiResponseApiResponseMessageStatus403;
    /**
     * Sales data temporarily unavailable
     */
    503: ApiResponseApiResponseMessageStatus503;
};

export type GetBookSalesRouteError = GetBookSalesRouteErrors[keyof GetBookSalesRouteErrors];

export type GetBookSalesRouteResponses = {
    /**
     * Success
     */
    200: ApiResponseSalesResponseStatus200;
};

export type GetBookSalesRouteResponse = GetBookSalesRouteResponses[keyof GetBookSalesRouteResponses];

export type GetBookSalesInfoRouteData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Comma-separated or repeated ISBN-13 / GTIN values. The first value is the selected book (used for the Amazon date); all values are aggregated for the market date and the market set.
         */
        isbns: string;
    };
    url: '/books/sales/info';
};

export type GetBookSalesInfoRouteErrors = {
    /**
     * The request parameters are missing or invalid.
     */
    400: ApiResponseApiResponseMessageStatus400;
    /**
     * Sales data is not enabled for the user or the organisation's salesDataLake is DISABLED.
     */
    403: ApiResponseApiResponseMessageStatus403;
    /**
     * Sales data temporarily unavailable
     */
    503: ApiResponseApiResponseMessageStatus503;
};

export type GetBookSalesInfoRouteError = GetBookSalesInfoRouteErrors[keyof GetBookSalesInfoRouteErrors];

export type GetBookSalesInfoRouteResponses = {
    /**
     * Success
     */
    200: ApiResponseSalesInfoResponseStatus200;
};

export type GetBookSalesInfoRouteResponse = GetBookSalesInfoRouteResponses[keyof GetBookSalesInfoRouteResponses];

export type GalleyProductsSearchData = {
    body?: GalleySearchRequest;
    path?: never;
    query?: never;
    url: '/galley/search/products';
};

export type GalleyProductsSearchErrors = {
    /**
     * The search request is invalid.
     */
    400: ApiResponseApiResponseMessageStatus400;
    /**
     * The search request failed validation.
     */
    422: ApiResponseApiResponseValidationErrorStatus422;
    /**
     * The product search failed.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type GalleyProductsSearchError = GalleyProductsSearchErrors[keyof GalleyProductsSearchErrors];

export type GalleyProductsSearchResponses = {
    /**
     * Success
     */
    200: ApiResponseGalleySearchResponseStatus200;
};

export type GalleyProductsSearchResponse = GalleyProductsSearchResponses[keyof GalleyProductsSearchResponses];

export type GalleyProductData = {
    body?: never;
    path: {
        /**
         * The product id
         */
        product_id: string;
    };
    query?: never;
    url: '/galley/products/{product_id}';
};

export type GalleyProductErrors = {
    /**
     * The product is not in the organisation's dedicated index.
     */
    404: ApiResponseApiResponseMessageStatus404;
    /**
     * The product read failed.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type GalleyProductError = GalleyProductErrors[keyof GalleyProductErrors];

export type GalleyProductResponses = {
    /**
     * Success
     */
    200: ApiResponseGalleyBookResponseStatus200;
};

export type GalleyProductResponse = GalleyProductResponses[keyof GalleyProductResponses];

export type GalleySeasonalEventsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Events that start within this many months (1-12, default 6)
         */
        months?: number;
        /**
         * Defaults to the organisation's marketplace region
         */
        region?: 'us' | 'uk' | 'de' | 'aus' | 'international';
    };
    url: '/galley/seasonal-events';
};

export type GalleySeasonalEventsErrors = {
    /**
     * The query parameters failed validation.
     */
    422: ApiResponseApiResponseValidationErrorStatus422;
    /**
     * The seasonal event read failed.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type GalleySeasonalEventsError = GalleySeasonalEventsErrors[keyof GalleySeasonalEventsErrors];

export type GalleySeasonalEventsResponses = {
    /**
     * Success
     */
    200: ApiResponseGalleySeasonalEventListStatus200;
};

export type GalleySeasonalEventsResponse = GalleySeasonalEventsResponses[keyof GalleySeasonalEventsResponses];

export type GalleyProjectCreateData = {
    body?: GalleyProjectCreateRequest;
    path?: never;
    query?: never;
    url: '/galley/projects';
};

export type GalleyProjectCreateErrors = {
    /**
     * A product is not in the organisation.
     */
    404: ApiResponseApiResponseMessageStatus404;
    /**
     * The project request failed validation.
     */
    422: ApiResponseApiResponseValidationErrorStatus422;
    /**
     * The project write failed.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type GalleyProjectCreateError = GalleyProjectCreateErrors[keyof GalleyProjectCreateErrors];

export type GalleyProjectCreateResponses = {
    /**
     * Success
     */
    201: ApiResponseGalleyProjectStatus201;
};

export type GalleyProjectCreateResponse = GalleyProjectCreateResponses[keyof GalleyProjectCreateResponses];

export type GalleyProjectData = {
    body?: never;
    path: {
        /**
         * The project id
         */
        project_id: string;
    };
    query?: never;
    url: '/galley/projects/{project_id}';
};

export type GalleyProjectErrors = {
    /**
     * The project is not in the organisation.
     */
    404: ApiResponseApiResponseMessageStatus404;
    /**
     * The project read failed.
     */
    500: ApiResponseApiResponseMessageStatus500;
};

export type GalleyProjectError = GalleyProjectErrors[keyof GalleyProjectErrors];

export type GalleyProjectResponses = {
    /**
     * Success
     */
    200: ApiResponseGalleyProjectStatus200;
};

export type GalleyProjectResponse = GalleyProjectResponses[keyof GalleyProjectResponses];

export type V1PostBlurbData = {
    body?: V1MetadataBlurbRequest;
    path?: never;
    query?: never;
    url: '/v1/metadata/blurb';
};

export type V1PostBlurbResponses = {
    /**
     * Success
     */
    200: ApiResponseV1MetadataBlurbResponseStatus200;
};

export type V1PostBlurbResponse = V1PostBlurbResponses[keyof V1PostBlurbResponses];

export type V1GetBlurbData = {
    body?: never;
    path: {
        /**
         * The identifier of the metadata entry
         */
        identifier: string;
    };
    query?: never;
    url: '/v1/metadata/blurb/{identifier}';
};

export type V1GetBlurbResponses = {
    /**
     * Success
     */
    200: ApiResponseV1MetadataBlurbResponseStatus200;
};

export type V1GetBlurbResponse = V1GetBlurbResponses[keyof V1GetBlurbResponses];

export type V1PostKeywordsData = {
    body?: V1MetadataKeywordRequest;
    path?: never;
    query?: never;
    url: '/v1/metadata/keywords';
};

export type V1PostKeywordsResponses = {
    /**
     * Success
     */
    200: ApiResponseV1MetadataKeywordResponseStatus200;
};

export type V1PostKeywordsResponse = V1PostKeywordsResponses[keyof V1PostKeywordsResponses];

export type V1GetKeywordsData = {
    body?: never;
    path: {
        /**
         * The identifier of the metadata entry
         */
        identifier: string;
    };
    query?: never;
    url: '/v1/metadata/keywords/{identifier}';
};

export type V1GetKeywordsResponses = {
    /**
     * Success
     */
    200: ApiResponseV1MetadataKeywordResponseStatus200;
};

export type V1GetKeywordsResponse = V1GetKeywordsResponses[keyof V1GetKeywordsResponses];

export type V1GetProductData = {
    body?: never;
    path: {
        /**
         * The Firestore product document ID
         */
        product_id: string;
    };
    query?: never;
    url: '/v1/products/{product_id}';
};

export type V1GetProductErrors = {
    /**
     * The product was not found in your organisation.
     */
    404: ApiResponseApiResponseMessageStatus404;
    /**
     * The API requests limit for your organisation was reached.
     */
    429: ApiResponseApiResponseMessageStatus429;
};

export type V1GetProductError = V1GetProductErrors[keyof V1GetProductErrors];

export type V1GetProductResponses = {
    /**
     * Success
     */
    200: ApiResponseProductResponseStatus200;
};

export type V1GetProductResponse = V1GetProductResponses[keyof V1GetProductResponses];
